import axios from 'axios';
import AccessToken from '@/services/auth-tenant';
import authTenant from '../auth.tenant.service';
import {
    data
} from 'jquery';
import url from 'postcss-url';
import moment from 'moment'
import store from '@/store/main.js';
import Cookies from 'js-cookie'
import { constrainPoint } from '@fullcalendar/core';
import { log } from 'console';

var CryptoJS = require("crypto-js");

const ACCESS_TOKEN = AccessToken();

const host = window.location.host;
const parts = host.split('.');

let tenantUrl = window.location.protocol + "//" + parts[0] + '.' + process.env.TENANT_API_ROOT;
let getshipUrl = process.env.GETSHIP_URL;

let config = {
    headers: {
        Authorization: 'Bearer ' + ACCESS_TOKEN.token,
        TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
};

const HandleTimeout = async (sendAxios) => {
    try {
        return await sendAxios;
    } catch (err) {
        if (err.code === 'ECONNABORTED') {
            return {
                status: 500,
                data: {
                    code: 'ECONNABORTED',
                    timeout: err.config.timeout,
                    message: `timeout: ${err.config.timeout} milliseconds`
                }
            };
        }
        return err.response;
    }
};

const signature = (queryString = "") => {
    const jsx = require("js-extension-ling");
    const params = jsx.queryStringToObject(queryString);

    const key = process.env.V2_APP_KEY;
    const partnerAppSecret = process.env.V2_APP_SECRET;
    const timestamp = new Date().getTime();
    let query = Object.entries(params).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {});
    query = {
        ...query, ...{
            key, timestamp
        }
    };
    let baseString = `secret=${partnerAppSecret}`;
    for (const key of Object.keys(query).sort()) {
        if ((typeof query[key] === "object" || typeof query[key] === 'function') && (query[key] !== null)) {
            let dataValue = Object.values(query[key]);
            query[key] = [];
            dataValue.map(function(value){
                query[key].push(value);
                baseString += `${key}[]=${value}`
            });
        } else if (Array.isArray(query[key])) {
            for (const value of query[key]) {
                baseString += `${key}[]=${value}`
            }
        } else {
            baseString += `${key}=${query[key]}`
        }
    }

    const hmac = CryptoJS.HmacSHA256(baseString, partnerAppSecret);
    const signature = hmac.toString(CryptoJS.digest);

    query = { ...query, signature };

    return '?' + $.param(query);
}

class Signature {
    create(query){
        return signature(query);
    }
}
class Setup {
    setUrl(newUrl) {
        tenantUrl = newUrl;
    }
}

class Authorization {
    async checkLogged() {
        return await axios.get(tenantUrl + '/v1/auth/check', config);
    }
}

const API_CUSTOMER = '/v1/service/customer'
const API_PRODUCT = '/v1/service/product'
const API_ROLE = '/v1/service/role'
const API_ORDER = '/v1/service/order'
const API_ORDER_GETPRODUCT = '/v1/service/order/getproduct'
const API_INTEGRATION = '/v1/service/integration'
const API_SETTING_GETPRODUCT = '/v1/service/setting/getproduct'
const API_SETTING_GETUSER = '/v1/service/setting/getuser'
const API_SETTING_GETUSERASSIGN = '/v1/service/setting/getuserproductassign'
const API_SALEPAGE_GETPRODUCT = '/v1/service/salepage/getproduct'
const API_TAG = '/v1/service/tag'
const API_ORDER_NOTIFY = '/v1/service/setting/order-notify'
const API_NOTIFY = '/v1/service/setting/notify'
const API_SHIPMENT_GETPRODUCT = '/v1/service/shipment/getproduct'
const API_SETTING_GETLOCATION = '/v1/service/location';
const API_PRODUCTLINK_GETPRODUCT = '/v1/service/product/link/getproduct'

const API_CUSTOMER_TAG = '/v2/customers/tags'
const API_CUSTOMER_ACTIVITY_STAFF = '/v2/customers/staffs'
const API_PAYMENTS_TAGS = '/v2/payments/tags'
const API_ACTIVITIES = '/v2/crm/activities'
const API_ACTIVITIES_STAFF = '/v2/crm/activities/staffs';
const API_ACTIVITIES_TAG = '/v2/crm/activities/tags';
const API_ACTIVITIES_CUSTOMER = '/v2/crm/activities/customers';
const API_ACTIVITIES_CUSTOMER_TAG = '/v2/crm/activities/tags/customer';

const API_PRODUCTLINK_ITEM_FILTER = '/v2/products/links/items';
const API_PRODUCTLINK_GETPRODUCTLINK= '/v2/products/links'
const API_INVENTORY_GETPRODUCT = '/v2/inventories/adjustments/warehouses'

const API_INVENTORY_GETSUPPLIER = '/v2/inventories/purchases/suppliers'
const API_INVENTORY_GETWAREHOUSE = '/v2/inventories/purchases/warehouses'
const API_INVENTORY_GETCHANNEL = '/v2/inventories/sales-channel'
const API_ADJUSTMENTS_GETWAREHOUSE = '/v2/inventories/adjustments/warehouses'
const API_SHIPMENTS_GETWAREHOUSE = '/v2/shipments/stocks/warehouses'
const API_IMPORTS_GETWAREHOUSE = '/v2/imports/stocks/warehouses'

const API_FULFILLMENT_PRODUCT_EXTERNAL = '/v2/fulfillment/search/product/select/external'
const API_FULFILLMENT_PRODUCT_INTERNAL = '/v2/fulfillment/search/product/select/internal'

const API_TIMESLOT = '/v1/service/shipment/pickup/time-slot';
const API_PRODUCT_TAG = '/v2/products/tags';
const API_PRODUCT_CATEGORIES = '/v2/products/categories';

const API_PRODUCT_RETURNORDER = '/v2/returns/products';
const API_SALEPAGE_NOTIFY_ORDER = '/v1/service/salepage/notify/order'

function handleApi(response){

    setTimeout(function() {
        $('.modal-right').modal('hide');
    }, 1000);

    const url = new URL('/', window.location.origin);
    window.location.href = url.toString();
}

class Tag {
    async getTag(queryString = '') {
        try{
            const response =  await axios.get(tenantUrl + '/v1/service/tag' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }

            return err;
        }
    }
    async getTagById(tagId) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/tag/' + tagId, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }

            return err;
        }
    }
    async postTag(data) {
        const response = await axios.post(tenantUrl + '/v1/service/tag', data, config);
        return response;
    }
    async putTag(tagId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/tag/' + tagId, data, config);
        return response;
    }
    async deleteTag(tagId) {
        const response = await axios.delete(tenantUrl + '/v1/service/tag/' + tagId, config);
        return response;
    }
    async getModuleTag(tagId, queryString = '') {
        const response = axios.get(tenantUrl + '/v1/service/tag/moduletag/' + tagId + '' + queryString, config);
        return response;
    }
}

class Tenant {
    async getTenant() {
        return await axios.get(tenantUrl + '/v1/service/tenant', config);
    }

    async getPlan() {
        const response = await axios.get(tenantUrl + '/v1/service/tenant/plan', config);
        return response;
    }

    async logOut(data = []) {

        const onlineDomain = Cookies.get('online') ? window.atob(Cookies.get('online')) : "";
        const currentDomain = (new URL(tenantUrl).host.split(".")[0])

        //เป็นเคสที่ว่า action logout tenant จากฝั่ง central, tenantUrl hot จะเป็น account ไม่ใช่ domin ร้าน

        const url = tenantUrl.replace(currentDomain, currentDomain == "account" && Cookies.get('tenantToken') ? onlineDomain : currentDomain);

        return await axios.post(url + '/v1/service/logout', data, config);
    }
}

class Bank {
    async getBank() {
        try{
           return await axios.get(tenantUrl + '/v1/service/bank', config);
        } catch (err) {
            console.error('getBank', error);

            if (err.response.status !== 403) {
                handleApi(err);
            }

            return err;
        }
    }
    async getBankById(bankId) {
        return await axios.get(tenantUrl + '/v1/service/bank/' + bankId, config);
    }
}

class BankAccount {
    async getBankAccount(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/bank-account' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }

            return err;
        }
    }
    async getBankAccountById(bankAccountId) {
        return await axios.get(tenantUrl + '/v1/service/bank-account/' + bankAccountId, config);
    }
    async postBankAccount(data) {
        const response = await axios.post(tenantUrl + '/v1/service/bank-account', data, config);
        return response;
    }
    async putBankAccount(bankAccountId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/bank-account/' + bankAccountId, data, config);
        return response;
    }
    async deleteBankAccount(bankAccountId) {
        const response = await axios.delete(tenantUrl + '/v1/service/bank-account/' + bankAccountId, config);;
        return response;
    }
    async setDefaultBankAccount(id, data) {
        return await axios.put(tenantUrl + '/v1/service/bank-account/' + id + '/setdefault', data, config);
    }
}

class Country {
    // async getCountry() {
    //     return await axios.get(tenantUrl + '/v1/service/country');
    // }
    async getCountry() {
        try{
            return await axios.get(tenantUrl + '/v1/service/country', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }

            return err;
        }
    }
    async getCountryByCode(code) {
        return await axios.get(tenantUrl + '/v1/service/country/' + code, config);
    }
}

class Home {

    async getHomePage(queryString = '') {
        return await axios.get(tenantUrl + '/v2/home' + signature(queryString), config);
    }
    async getNews(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/news' + queryString, config);
    }

    async getChangeLog(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/changelog' + queryString, config);
    }

    async getBanner(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/banner' + queryString, config);
    }

    async getVdo(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/vdo' + queryString, config);
    }

    async getCalendar(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/calendar' + queryString, config);
    }

    async getEvent(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/event' + queryString, config);
    }

    async getCallCenter(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/home/callcenter' + queryString, config);
    }
}

class Social {
    async faceBook(data = '') {
        try{
            const response = await axios.post(tenantUrl + '/v2/facebook' + signature(), data, config);
            return response;

        } catch (err) {
            return err;
        }
    }
}
class Customer {
    async listCustomer(queryString = '', options = {}) {
        let response = await axios.get(tenantUrl + '/v2/customers' + signature(queryString), config);
        if (options.dataReady) {
            return response.data;
        }
        return response;
    }
    async getCustomer(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/customer' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getCustomerAddress(customerId, options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/customer/' + customerId + '/getaddress', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getFirstCustomerAddress(customerId, options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/customer/' + customerId + '/getaddress', config);
        if (options.dataReady) {
            const [first] = response.data.data;
            return first;
        }
        return response;
    }
    async getCustomerInfo(customerId, options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/customer/' + customerId + '/getinfo', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getCustomerDashboard(customerId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/dashboard' + signature(), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;

        } catch (err) {
            return err.response;
        }
    }
    async getCustomerInfoForOrder(customerId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/info-data' + signature(), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;

        } catch (err) {
            return err.response;
        }
    }
    async getCustomerInfoV2(customerId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + signature(), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;

        } catch (err) {
            return err.response;
        }
    }
    async getCustomerActivity(customerId, data, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/activities' + signature(data), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async pinActivity(customerId, activitiesId, data = null, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/activities/'+ activitiesId + '/pin' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async unpinActivity(customerId, activitiesId, data = null, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/activities/'+ activitiesId + '/unpin' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async markIncomplete(customerId, activitiesId, data = null, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/activities/'+ activitiesId + '/incomplete' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async markComplete(customerId, activitiesId, data = null, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/activities/'+ activitiesId + '/complete' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getCustomerNoteV2(customerId, data, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/notes' + signature(data), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putPinNote(customerId, data, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/pin' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putUnPinNote(customerId, data, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/unpin' + signature(), data, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putDeleteNote(customerId, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v2/customers/' + customerId + '/notes' + signature(), data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getCustomerActivityLog(customerId, data, options = {}){
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/logs' + signature(data), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getOrder(customerId, data, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + customerId + '/orders' + signature(data), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getCustomerSaleOrder(customerId) {
        return await axios.get(tenantUrl + '/v1/service/customer/' + customerId + '/getsalesorder', config)
    }
    async postCustomer(data, options = {}) {
        const response = await axios.post(tenantUrl + '/v1/service/customer', data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async putCustomer(customerId, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/customer/' + customerId, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async deleteCustomer(customerId, options = {}) {
        const response = await axios.delete(tenantUrl + '/v2/customers/' + customerId + signature(), config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async deleteBatchCustomer(customerIds, options = {}) {
        const response = await axios.put(tenantUrl + '/v2/customers/batch/delete' + signature(), customerIds, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async postMedia(customerId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/customer/' + customerId + '/addmedia', data, config);
        return response;
    }
    async setMediaByCustomerId(customerId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/customer/' + customerId + '/addmediabyid', data, config);
        return response;
    }
    async addNote(customerId, data, options = {}) {
        try{
            const response = await axios.post(tenantUrl + '/v1/service/customer/' + customerId + '/addnote', data, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postTag(id, data) {
        const response = axios.post(tenantUrl + '/v1/service/customer/' + id + '/addtag', data, config);
        return response;
    }
    async getTag(customerId) {
        return await axios.get(tenantUrl + '/v1/service/customer/' + customerId + '/gettag', config);
    }
    async deleteCustomerTag(customerId, tagId) {
        const response = await axios.put(tenantUrl + '/v2/customers/' + customerId +"/tag/delete" + signature(), tagId, config);
        // const response = await axios.delete(tenantUrl + '/v1/service/customer-tag/' + tagId, config);
        return response;
    }
    async getCustomerById(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/customer/' + id, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async updateNote(customerId, data) {
        try{
            const response = await axios.post(tenantUrl + '/v1/service/customer/' + customerId + '/updatenote', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postAddTag(customerTagId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/customer/' + customerTagId + '/addtagbyid', data, config);
        return response;
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/customer/setting', config);
        return response;
    }

    async getCustomerCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/create' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postCustomerCreate(data, queryString='') {
        const response = await axios.post(tenantUrl + '/v2/customers'+ signature(queryString), data, config)
        .then(response => {
            return response;
        }).catch(function (error) {
            if (error.response) {
                return error.response;
            }
        });
        return response;
    }

    async getCustomerEdit(id, queryString='') {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/' + id + '/edit' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async putCustomerEdit(id, data,queryString='') {
        const response = await axios.put(tenantUrl + '/v2/customers/'+id+ signature(queryString), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }
    async postSendCustomer(customerId,integrationId,data ) {
        try{
            const response = await axios.post(tenantUrl + '/v2/customers/'+customerId+'/crm/'+integrationId+'/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putSendCustomer(data ) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/batch/crm/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putUnBlacklistCustomer(data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/batch/unblacklist' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putBlacklistCustomer(data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/batch/blacklist' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putUnBlacklistCustomerDetail(customerId,data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/'+customerId+'/unblacklist' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putBlacklistCustomerDetail(customerId,data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/customers/'+customerId+'/blacklist' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getSmsCustomer(queryString='') {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/sms' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getSendSmsCustomer(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/customers/sms/customer' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async postSendSmsCustomer(data, queryString='') {
        const response = await axios.post(tenantUrl + '/v2/customers/sms'+ signature(queryString), data, config)
        .then(response => {
            return response;
        }).catch(function (error) {
            if (error.response) {
                return error.response;
            }
        });
        return response;
    }
    async checkReturnOrder(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/customers/check-return'+ signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class CustomerGroup {
    async getCustomerGroup(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/customer-group' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
}
class User {
    async getUser(queryString = '', options = {}) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/user' + queryString, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getCurentUser() {
        const response = await axios.get(tenantUrl + '/v1/service/user/current', config);
        return response;
    }

    async getUserById(userId) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/user/' + userId, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async putUser(userId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/user/' + userId, data, config);
        return response;
    }

    async blockUser(userId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/user/' + userId + '/block', data, config);
        return response;
    }

    async deleteUser(userId) {
        const response = axios.delete(tenantUrl + '/v1/service/user/' + userId, config);
        return response;
    }

    async getWalletBalanceAll() {
        const response = await axios.get(tenantUrl + '/v1/service/user/get-wallet-balance-all', config);
        return response;
    }

    async getWalletTransactionShipment(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/user/wallet-transaction-shipment' + queryString, config);
        return response;
    }

    async addBookmark(data) {
        const response = await axios.put(tenantUrl + '/v1/service/user', data, config);
        return response;
    }

    async getCustomerAddress(userId) {
        return await axios.get(tenantUrl + '/v1/service/user/' + userId + '/customeraddress', config);
    }
}

class UserV2 {
    async getUserById(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/users/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getUserLogs(id, queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/users/' + id + '/logs' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
}

class Invitation {
    async getInvitation(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/invitation' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postInvitation(data) {
        const response = await axios.post(tenantUrl + '/v1/service/invitation', data, config);
        return response;
    }
    async deleteInvitation(id) {
        const response = await axios.delete(tenantUrl + '/v1/service/invitation/' + id, config);
        return response;
    }
}

class Note {
    async getNote() {
        const response = await axios.get(tenantUrl + '/v1/service/note', data, config);
        return response;
    }
    async getNoteById(noteId) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/note/' + noteId, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postNote(data) {
        const response = await axios.post(tenantUrl + '/v1/service/note', data, config);
        return response;
    }
    async putNote(noteId, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/note/' + noteId, data, config);
        if (options.dataReady) {
            return response.data;
        }
        return response;

    }
    async deleteNote(noteId) {
        const response = await axios.delete(tenantUrl + '/v1/service/note/' + noteId, config);
        return response;
    }
}

class ProductTag {
    async getProductTag() {
        return await axios.get(tenantUrl + '/v1/service/product-tag', config);
    }
    async getProductTagById(productTagId) {
        return await axios.get(tenantUrl + '/v1/service/product-tag/' + productTagId, config);
    }
    async putProductTag(productTagId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/product-tag/' + productTagId, data, config);
        return response;
    }
    async deleteProductTag(productTagId) {
        const response = await axios.delete(tenantUrl + '/v1/service/product-tag/' + productTagId, config);
        return response;
    }
}

class ProductType {
    async getProductType() {
        const response = await axios.get(tenantUrl + '/v1/service/product-type', config);
        return response;
    }
}

class ProductConfig {
    async getProductConfig() {
        return await axios.get(tenantUrl + '/v1/service/product-config', config);
    }
    async getProductConfigById(productConfigId) {
        return await axios.get(tenantUrl + '/v1/service/product-type/' + productConfigId, config);
    }
}

class ProductVariation {
    async getProductVariation() {
        const response = await axios.get(tenantUrl + '/v1/service/product-variation', config);
        return response;
    }
    async getProductVariationById(productVariationId) {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productVariationId, config);
    }
    async getAttributeProductVariation(productVariationId) {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productVariationId + '/getattribute', config);
    }
    async getAttributeByProductId(productId) {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productId + '/getattributeByProductId', config);
    }
    async getAttributeOptionProductVariation(productId) {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productId + '/getattributeOption', config);
    }

    async getAttributeOptionByProductAttribute(productId, attributeId) {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productId + '/getattributeOptionByProductConfigIdAndAttributeId/' + attributeId, config);
    }

    async getattributeOptionGroupByProductId(productId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/product-variation/' + productId + '/getattributeOptionGroupByProductId' + queryString, config);
    }
}

class Product {
    async getProduct(queryString) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/product' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getProductById(id) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/product/' + id, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getVariation(productId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/product/' + productId + '/getvariation' + queryString, config);
    }
    async getConfig(productId) {
        return await axios.get(tenantUrl + '/v1/service/product/' + productId + '/getconfig');
    }
    async getMedia(productId) {
        return await axios.get(tenantUrl + '/v1/service/product/' + productId + '/getmedia', config);
    }
    async getTag(productId) {
        return await axios.get(tenantUrl + '/v1/service/product/' + productId + '/gettag', config);
    }
    async postTag(id, data) {
        const response = axios.post(tenantUrl + '/v1/service/product/' + id + '/addtag', data, config);
        return response;
    }
    async postProduct(data) {
        const response = axios.post(tenantUrl + '/v1/service/product', data, config);
        return response;
    }

    async putProduct(id, data) {
        const response = axios.put(tenantUrl + '/v1/service/product/' + id, data, config);
        return response;
    }

    async postMedia(productId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/product/' + productId + '/addmedia', data, config);
        return response;
    }
    async deleteProductMedia(productId) {
        const response = await axios.delete(tenantUrl + '/v1/service/product-media/' + productId, config);
        return response;
    }

    deleteProduct(id) {
        const response = axios.delete(tenantUrl + '/v1/service/product/' + id, config);
        return response;
    }

    async postDuplicateProduct(productId, data = null) {
        const response = await axios.post(tenantUrl + '/v1/service/product/' + productId + '/duplicate', data, config);
        return response;
    }
    async getBarcodeCheck(queryString) {
        return await axios.get(tenantUrl + '/v1/service/product/barcode-check' + queryString, config);
    }

    async getIntegration(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/product/integration' + queryString, config);
        if (options.dataReady) {
            return response.data;
        }
        return response;
    }
}

class ProductV2 {
    async getProduct(queryString) {
        const response = await axios.get(tenantUrl + '/v2/products' + signature(queryString), config);
        return response;
    }

    async getWarehouses(queryString) {
      const response = await axios.get(tenantUrl + '/v2/products/warehouses' + signature(queryString), config);
      return response;
    }

    async getCategory(queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/categories' + signature(queryString), config);
      return response;
    }

    async getProductInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/products/' + id + signature(), config);
        return response;
    }

    async getProductHeader(id) {
        const response = await axios.get(tenantUrl + '/v2/products/' + id + '/info-data' + signature(), config);
        return response;
    }
    async getProductLog(id,queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/' + id + '/activity-logs'+ signature(queryString), config);
        return response;
    }
    async getProductLogMovements(id,queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/' + id + '/movements'+ signature(queryString), config);
        return response;
    }
    async postAddTag(productId,data) {
        const response = await axios.post(tenantUrl + '/v2/products/'+ productId + '/tags' + signature(), data, config);
        return response;
    }
    async deleteTag(productId,tagId) {
        const response = await axios.delete(tenantUrl + '/v2/products/'+ productId +'/tags/' + tagId + signature(), config);
        return response;
    }
    async markAsActive(productIds) {
        const response = await axios.put(tenantUrl + '/v2/products/batch/active' + signature(), productIds, config);
        return response;
    }
    async markAsInactive(productIds) {
        const response = await axios.put(tenantUrl + '/v2/products/batch/archive' + signature(), productIds, config);
        return response;
    }
    async postSendProduct(productId,integrationId,data ) {
        try{
            const response = await axios.post(tenantUrl + '/v2/products/'+productId+'/crm/'+integrationId+'/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putSendProduct(data ) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/batch/crm/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putUpdateQtyMkp(id = '', data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/' + id + '/update-stock' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductMkp(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/' + id + '/marketplace' + signature(),  config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductSet(queryString,productId) {
        const response = await axios.get(tenantUrl + '/v2/products/delete-sets'+ signature(queryString), config);
        return response;
    }
    async getProductSetList(productId) {
      const response = await axios.get(tenantUrl + `/v2/products/list-product-set/` + productId + signature(), config);
      return response;
    }
    async updateSalableProduct(data='') {
      const response = await axios.put(tenantUrl + '/v2/products/update-stock-salable'+ signature(), data, config);
      return response;
    }
    async getReservedList(queryString) {
      const response = await axios.get(tenantUrl + `/v2/products/reserved` + signature(queryString), config);
      return response;
    }
    async getProductUpdateSalable(productId,type) {
        const response = await axios.get(tenantUrl + `/v2/products/` + productId + `/` +type +`/update-stocks` + signature(), config);
        return response;
    }
    async putProductUpdateSalable(productId, data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/' + productId + '/update-stocks' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class Category{
    async getCategoryCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/create' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postCreateCategory(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/categories' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getCategoryList(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getCategoryDetail(categoryId = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/' + categoryId + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getTreeCategory(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/tree' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductItems(categoryId, queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/'+ categoryId + '/items' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getSubCategoryItems(categoryId, queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/'+ categoryId + '/sub-category' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getActivityLogs(categoryId, queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/'+ categoryId + '/logs' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getCategoryEdit(id, queryString='') {
        try{
            const response = await axios.get(tenantUrl + '/v2/categories/' + id + '/edit' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putCategoryEdit(id, data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/categories/' + id + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async deleteCategoryById(categoryId = null) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/categories/' + categoryId + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}
class ProductLink {
    async postRegisterProductLink() {
        try{
            const response = await axios.post(tenantUrl + '/v2/products/links/register' + signature(), [], config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductLinkSimple(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/product/link/getproduct' + queryString, config);
    }

    async getProductVariation(productId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/product/link/' + productId + '/getproductvariation' + queryString, config);
    }

    async getProductLinkList(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links' + signature(queryString), config);
            return response;
        } catch (err){
            return err.response;
        }

    }

    async getProductFilter(queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/links/items' + signature(queryString), config);
        return response;
    }

    async getProductCount(queryString = "") {
        const response = await axios.get(tenantUrl + '/v1/service/product/link/getproductcount' + queryString, config);
        return response;
    }
    async postCreateLink(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/products/links' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductLinkView(id = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/' + id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putUpdateQty(id = '', data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/links/' + id + '/update-qty' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putEditLink(id = '', data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/links/' + id + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getActivityLog(id = '', queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/links/' + id + '/logs' + signature(queryString), config);
        return response;
    }
    async getLogsMovements(id = '', queryString) {
        const response = await axios.get(tenantUrl + '/v2/products/links/' + id + '/movements' + signature(queryString), config);
        return response;
    }
    async putUnlink(id = '', data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/links/' + id + '/unlink' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getWarehousesList(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/warehouses'+ signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putContinueProductLink() {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/links/cancel-unlink' + signature(), [], config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putCancelUnlink() {
        try{
            const response = await axios.put(tenantUrl + '/v2/products/links/confirm-unlink' + signature(), [], config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductLinkCreate() {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/create'+ signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductLinkUpdate(id, queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/'+ id + '/update' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putWarehouseUpdate(id, data) {
      try{
          const response = await axios.put(tenantUrl + '/v2/products/links/'+ id + '/specific-warehouses' + signature(), data, config);
          return response;
      } catch (err) {
          return err.response;
      }
  }
    async getUnlinkData(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/'+ id + '/unlink' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReservedLists(id, queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/links/'+ id + '/reserved' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}
class Variation {
    async getVariation(queryString = "") {
        const response = await axios.get(tenantUrl + '/v1/service/attribute' + queryString, config);
        return response;
    }

    async getVariationById(id = "") {
        const response = await axios.get(tenantUrl + '/v1/service/attribute/' + id, config);
        return response;
    }

    async postVariation(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/attribute', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async putVariation(data, id) {
        try {
            const response = await axios.put(tenantUrl + '/v1/service/attribute/' + id, data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async deleteVariation(id = "") {
        const response = axios.delete(tenantUrl + '/v1/service/attribute/' + id, config);
        return response;
    }

    async validateDeleteVariant(optionId = "") {
        const response = axios.get(tenantUrl + '/v1/service/attribute/' + optionId + '/validateVariant', config);
        return response;
    }

    async validateDeleteVariation(optionId = "") {
        const response = axios.get(tenantUrl + '/v1/service/attribute/' + optionId + '/validateVariation', config);
        return response;
    }

}

class VariationV2 {
    async getVariation(queryString = "") {
        const response = await axios.get(tenantUrl + '/v2/products/attributes' + signature(queryString), config);
        return response;

    }
}

class Attribute {
    async getAttribute() {
        try{
            return await axios.get(tenantUrl + '/v1/service/attribute', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getAttributeById(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/attribute/' + id, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getOption(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/attribute/' + id + '/getoption', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async filterSpecialCharacter(text) {
        const endpoint = `${tenantUrl}/v1/service/filter-special-character`;
        return await axios.get(endpoint, { params: { text }, headers: config.headers });
    }
}


class AttributeOption {
    async getOption(id) {
        return await axios.get(tenantUrl + '/v1/service/attribute-option/' + id, config);
    }
    async getOptionById(id) {
        return await axios.get(tenantUrl + '/v1/service/attribute/' + id, config);
    }
    async getConfig(id) {
        return await axios.get(tenantUrl + '/v1/service/attribute-option/' + id + '/getconfig', config);
    }
}

class ProductSet {
    async get(queryString) {
        const response = await axios.get(tenantUrl + '/v1/service/product-set' + queryString, config);
        return response;
    }
    async getById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/product-set/' + id, config);
        return response;
    }
    async create(data) {
        return await axios.post(tenantUrl + '/v1/service/product-set', data, config);
    }
    async update(id, data) {
        return await axios.put(tenantUrl + '/v1/service/product-set/' + id, data, config);
    }
    async delete(id) {
        return await axios.delete(tenantUrl + '/v1/service/product-set/' + id, config);
    }
}

class PromotionBundleRule {
    async get() {
        return await axios.get(tenantUrl + '/v1/service/promotion-bundle-rule', config);
    }
}
class Promotion {
    async get(queryString) {
        try{
            return await axios.get(tenantUrl + '/v1/service/promotion' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async create(data) {
        return await axios.post(tenantUrl + '/v1/service/promotion', data, config);
    }
    async update(id, data) {
        return await axios.put(tenantUrl + '/v1/service/promotion/' + id, data, config);
    }
    async postMedia(promotionId, data) {
        return await axios.post(tenantUrl + '/v1/service/promotion/' + promotionId + '/addmedia', data, config);
    }
    async getPromotionById(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/promotion/' + id, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getproducts(id) {
        return await axios.get(tenantUrl + '/v1/service/promotion/' + id + '/getproducts', config);
    }
    async deletePromotionMedia(id) {
        return await axios.delete(tenantUrl + '/v1/service/promotion-media/' + id, config);
    }
    async postDuplicatePromotion(promotionId, data = null) {
        return await axios.post(tenantUrl + '/v1/service/promotion/' + promotionId + '/duplicate', data, config);
    }

    async getPromotionActivityLogById(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/promotion/' + id + '/logs', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}

class PromotionV2 {
    async get(queryString = "") {
        const response = await axios.get(tenantUrl + '/v2/promotions' + signature(queryString), config);
        return response;
    }
}

class Role {
    async getRole(queryString = '', options = {}) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/role' + queryString, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getRoleByid(roleId) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/role/' + roleId, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getPermission(roleId) {
        return await axios.get(tenantUrl + '/v1/service/role/' + roleId + '/getpermission', config);
    }
    async postRole(data) {
        const response = await axios.post(tenantUrl + '/v1/service/role', data, config);
        return response;
    }
    async putRole(roleId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/role/' + roleId, data, config);
        return response;
    }
    async deleteRole(roleId) {
        const response = await axios.delete(tenantUrl + '/v1/service/role/' + roleId, config);
        return response;
    }
    async Activitylogs(roleId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/role/' + roleId + '/activity-logs' + queryString, config)
    }
}

class PermissionGroup {
    async getPermissionGroup() {
        return await axios.get(tenantUrl + '/v1/service/permission-group', config);
    }
    async getPermissionGroupByName(name) {
        return await axios.get(tenantUrl + '/v1/service/permission-group/' + name, config);
    }

    async getAllPermission() {
        try {
            return await axios.get(tenantUrl + '/v1/service/permission?select_all=yes', config);
        } catch (err) {
            return err.response;
        }
    }
}


class Permission {
    async postHasPermission(permissionName) {
        var data = { permissionName: permissionName };
        try{
            return await axios.post(tenantUrl + '/v1/service/has/permission', data, config);
        } catch (err) {
            return err.response;
        }
    }

}

class Order {
    async getOrder(queryString = '') {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/order' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getProduct(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/order/getproduct' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getProductVariation(productId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/order/' + productId + '/getproductvariation' + queryString, config);
    }

    async getProductPromotionCount(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/order/getproductpromotioncount' + queryString, config);
    }

    async getProductPromotion(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/order/getproductpromotion' + queryString, config);
    }

    async getPromotionProducts(id) {
        return await axios.get(tenantUrl + '/v1/service/order/promotion/' + id + '/getproducts', config);
    }

    async getSalesOrderLog(orderId) {
        return await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/getlog', config);
    }

    async getSettingUpsell(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/order/setting/upsell' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getOrderTabCount(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/order/getordertabcount' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getOrderByID(id) {
        try {
            // const response = await axios.get(tenantUrl + '/v2/orders/' + id  + signature(id), config);
            const response = await axios.get(tenantUrl + '/v1/service/order/' + id, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getOrderItem(orderId) {
        return await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/getitemordered', config);
    }
    async getPaymentOrderById(orderId) {
        return await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/getpayment', config);
    }
    async getShippingAddress(orderId) {
        return await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/getshippingaddress', config);
    }
    async postOrder(data) {
        return await HandleTimeout(axios.post(tenantUrl + '/v1/service/order', data, Object.assign({timeout: 30000}, config)));
    }

    async putOrder(orderId, formData) {
        return await HandleTimeout(axios.put(tenantUrl + '/v1/service/order/' + orderId, formData, Object.assign({timeout: 30000}, config)));
    }

    async postPayment(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/addpayment', data, config);
        return response;
    }

    async putPayment(paymentId, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.post(tenantUrl + '/v1/service/order-payment/' + paymentId, data, config);
        return response;
    }

    async deletePayment(paymentId) {
        const response = await axios.delete(tenantUrl + '/v1/service/order-payment/' + paymentId, config);
        return response;
    }

    async postAddNote(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/addnote', data, config);
        return response;
    }
    async putUpdateNote(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/updatenote', data, config);
        return response;
    }
    async getOrderNoteMedia(queryString = '') {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/order/' + queryString + '/getNoteMedia', config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async putUpdateShippingAddress(orderId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/updateshippingaddress', data, config);
        return response;
    }
    async putCancleOrder(orderId, data = null) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/cancel', data, config);
        return response;
    }

    async putCancelShipment(data) {
        const response = await axios.put(tenantUrl + '/v1/service/order/canceledShipment', data, config);
        return response;
    }
    async checkShipment(orderId) {
        const response = await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/checkshipment', config);
        return response;
    }
    async putUpdateBillingAddress(orderId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/updatebillingaddress', data, config);
        return response;
    }
    async putConfirmPayment(orderId, data = null) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/confirmpayment', data, config);
        return response;
    }
    async putConfirmPaymentById(paymentId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order-payment/' + paymentId, data, config);
        return response;
    }

    async deleteNote(noteId) {
        const response = await axios.delete(tenantUrl + '/v1/service/order-note/' + noteId, config);
        return response;
    }

    async getIntegration(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/order/getintegration' + queryString, config);
        if (options.dataReady) {
            return response.data;
        }
        return response;
    }

    async getCustomer(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/order/customer' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postCustomer(data, options = {}) {
        const response = await axios.post(tenantUrl + '/v1/service/order/customer', data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async putCustomer(customerId, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/order/customer/' + customerId, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async addCustomerNote(customerId, data, options = {}) {
        const response = await axios.post(tenantUrl + '/v1/service/order/customer/' + customerId + '/addnote', data, config);
        if (options.dataReady) {
            return response.data;
        }
        return response;
    }

    async getPaymentMethod(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/order/payment-method' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/order/setting', config);
        return response;
    }

    async postBulkConfirmCod(data = null) {
        try {
            response = await axios.post(tenantUrl + '/v1/service/order/confirm-cod', data, config);
            return response
        } catch (err) {
            return err.response;
        }
    }

    async postConfirmCod(orderId) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/confirm-cod', null, config);
        return response;
    }

    async getReasonCancelOrder(orderId) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/reason-cancel', null, config);
        return response;
    }


    async getOrderMarketplaceDetail(orderId) {
        const response = await axios.get(tenantUrl + '/v1/service/order/' + orderId + '/details', config);
        return response;
    }

    async confirmCancel(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/confirm-cancel', data, config);
        return response;
    }

    async confirmCancelByBuyer(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/decide-cancel', data, config)
        .then(response => {
            return response;
        }).catch(function (error) {
            if (error.response) {
                return error.response;
            }
        });
        return response;

        // const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/decide-cancel', data, config);
        // return response;
    }

    async putBillingAddress(orderId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/putbillingaddress', data, config);
        return response;
    }

    async putShippingAddress(orderId, data) {
        const response = await axios.put(tenantUrl + '/v1/service/order/' + orderId + '/putshippingaddress', data, config);
        return response;
    }

    async getTrackingShortenUrl(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/order/getshortenurl' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async notConfirmCodByInId(data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/notConfirmCodByInId', data, config);
        return response;
    }

    async getInvoicesBySalesOrderId(data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/invoices', data, config);
        return response;
    }

    async postAddTag(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/addtagbyid', data, config);
        return response;
    }
    async deleteOrderTag(tagId) {
        const response = await axios.delete(tenantUrl + '/v1/service/order-tag/' + tagId, config);
        return response;
    }

    async getIntegration(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/order/integration' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }
    async putPayment(paymentId, data) {
        let addConfig = config;
        addConfig['header'] = { 'Content-Type': 'multipart/form-data' };
        const response = await axios.post(tenantUrl + '/v1/service/order/payment/' + paymentId, data, config);
        return response;
    }

    async getOrderStatus(queryString) {
        try {
            return await axios.get(tenantUrl + '/v1/order/chk-status', { params: queryString });
        } catch (err) {
            return err.response;
        }
    }

    async getOrderTrackingDetail(queryString) {
        try {
            return await axios.get(tenantUrl + '/v1/order/chk-orders', { params: queryString });
        } catch (err) {
            return err.response;
        }
    }

    async getMessageTemplate(queryString) {
        return await axios.get(tenantUrl + '/v1/service/order/message-template' + queryString, config);
    }

    async postCreateShipment(orderId, data = {}) {
        const response = await axios.post(tenantUrl + '/v1/service/order/' + orderId + '/create-shipment', data, config);
        return response;
    }

    async getCreateData(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/order/create' + queryString, config);
        return response;
    }

    async postCreateInvoice(data = {}) {
        try {
            return await axios.post(tenantUrl + '/v1/service/order/create-invoices', data, config);
        } catch (err) {
            return err.response;
        }
    }
}

class OrderV2 {
    async getOrder(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/orders' + signature(queryString), config);
        return response;
    }

    async postOrder(data = {}) {
        return await HandleTimeout(axios.post(tenantUrl + '/v2/orders/create' + signature(), data, Object.assign({timeout: 30000}, config)));
    }

    async postOrderlink(orderId, queryString='') {
        try {
            return await axios.post(tenantUrl + '/v2/orders/' + orderId + '/link' + signature(queryString), '', config);
        } catch (err) {
            return err.response;
        }
    }

    async getOrderByID(orderId) {
        try {
            return await axios.get(tenantUrl + '/v2/orders/' + orderId + signature(), config);
        } catch (err) {
            return err.response;
        }
    }

    async postBatchConfirmCod(data = {}) {
        try {
            return await axios.post(tenantUrl + '/v2/orders/batch/confirm-cod' + signature(), data, config);
        } catch (err) {
            return err.response;
        }
    }

    async sendOrderErp(id, data = {}) {
        try {
            return await axios.post(tenantUrl + '/v2/orders/erp/' + id + '/send-order' + signature(), data, config);
        } catch (err) {
            return err.response;
        }
    }

    async postSendOrderCrm(orderId, integrationId, data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/orders/'+orderId+'/crm/'+integrationId+'/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }


    async putSendOrderCrm(data) {
        try {
            const response = await axios.put(tenantUrl + '/v2/orders/batch/crm/send' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getCustomer(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v2/orders/customer' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async putUpdateBillingAddress(orderId, data) {
        const response = await axios.put(tenantUrl + `/v2/orders/${orderId}/edit-billing-address` + signature(), data, config);
        return response;
    }

    async postCheckOrderDuplicateData(data = {}) {
        const response = await axios.post(tenantUrl + '/v2/orders/is-duplicate' + signature(), data, config);
        return response;
    }
}

class OrderV3 {
    async getOrderElasticSearch(queryString = '') {
        const response = await axios.get(tenantUrl + '/v3/orders/elasticsearch' + signature(queryString), config);
        return response;
    }

    async getOrder(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v3/orders' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class OrderDraft {
    async getOrderDraft(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/orders/draft' + signature(queryString), config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err.response;
        }
    }

    async postOrderlink(orderId, queryString='') {
        try {
            return await axios.post(tenantUrl + '/v2/orders/draft/' + orderId + '/link' + signature(queryString), '', config);
        } catch (err) {
            return err.response;
        }
    }

    async postCreateOrderDraft(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/orders/draft' + signature() , data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getOrderDraftByID(orderDraftId) {
        try {
            const response = await axios.get(tenantUrl + '/v2/orders/draft/' + orderDraftId + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async createOrderMarkAs(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/orders/draft/convert-order' + signature() , data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async deleteOrderDraft(data = []) {
        try{
            const response = await axios.put(tenantUrl + '/v2/orders/draft' + signature() , data , config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getEditOrderDraftByID(orderDraftId) {
        try {
            const response = await axios.get(tenantUrl + '/v2/orders/draft/' + orderDraftId + '/edit' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async putSaveEditOrderDraftByID(orderDraftId, data) {
        try {
            const response = await axios.put(tenantUrl + '/v2/orders/draft/' + orderDraftId + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getMessageTemplateOrderDraft() {
        try {
            const response = await axios.get(tenantUrl + '/v2/orders/draft/message-template' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class Automation {
    async getAutomation(queryString = ''){
        const response = await axios.get(tenantUrl + '/v1/service/automation' + queryString, config);
        return response;
    }
    async getCreateData(queryString = ''){
        const response = await axios.get(tenantUrl + '/v1/service/automation/create' + queryString, config);
        return response;
    }
    async postCreateData(data){
        const response = await axios.post(tenantUrl + '/v1/service/automation/create' , data, config);
        return response;
    }
    async getEditData(automationId){
        const response = await axios.get(tenantUrl + '/v1/service/automation/' + automationId + '/edit', config);
        return response;
    }
    async putEditData(automationId, data){
        const response = await axios.put(tenantUrl + '/v1/service/automation/' + automationId + '/edit', data, config);
        return response;
    }
    async getDuplicateData(automationId){
        const response = await axios.get(tenantUrl + '/v1/service/automation/' + automationId + '/duplicate', config);
        return response;
    }
    async postDuplicateData(data){
        const response = await axios.post(tenantUrl + '/v1/service/automation/duplicate' , data, config);
        return response;
    }
    async getInformation(automationId){
        const response = await axios.get(tenantUrl + '/v1/service/automation/' + automationId, config);
        return response;
    }
}

class AutomationV2 {
    async getAutomation(queryString = ''){
        const response = await axios.get(tenantUrl + '/v2/automation' + signature(queryString), config);
        return response;
    }
    async getCreateData(queryString = ''){
        const response = await axios.get(tenantUrl + '/v2/automation/create' + signature(queryString), config);
        return response;
    }
    async postCreateData(data){
        const response = await axios.post(tenantUrl + '/v2/automation/create' + signature(), data, config);
        return response;
    }
    async getEditData(automationId){
        const response = await axios.get(tenantUrl + '/v2/automation/' + automationId + '/edit' + signature(), config);
        return response;
    }
    async putEditData(automationId, data){
        const response = await axios.put(tenantUrl + '/v2/automation/' + automationId + '/edit' + signature(), data, config);
        return response;
    }
    async getDuplicateData(automationId){
        const response = await axios.get(tenantUrl + '/v2/automation/' + automationId + '/duplicate' + signature(), config);
        return response;
    }
    async postDuplicateData(data){
        const response = await axios.post(tenantUrl + '/v2/automation/duplicate' + signature(), data, config);
        return response;
    }
    async getInformation(automationId){
        const response = await axios.get(tenantUrl + '/v2/automation/' + automationId + signature(), config);
        return response;
    }
}
class Payment {
    async getPayment(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/order-payment' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postPayment(data) {
        const response = await axios.post(tenantUrl + '/v1/service/order-payment', data, config);
        return response;
    }
    async getAllPayment(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/payment' + queryString, config);
        return response;
    }
    async getOrder(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/payment/order' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postAddPayment(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/payment/' + orderId + '/addpayment', data, config);
        return response;
    }
    async putPayment(paymentId, data) {
        let addConfig = config;
        addConfig['header'] = { 'Content-Type': 'multipart/form-data' };
        const response = await axios.post(tenantUrl + '/v1/service/payment/' + paymentId, data, config);
        return response;
    }
    async putConfirmPaymentById(paymentId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/payment/' + paymentId, data, config);
        return response;
    }
    async putConfirmPaymentAll(data) {
        const response = await axios.post(tenantUrl + '/v1/service/payment/confirm-payment-all', data, config);
        return response;
    }

    async getSlipVerifyRetry(paymentId, data = '') {
        const response = await axios.post(tenantUrl + '/v1/service/payment/' + paymentId + '/slip-verify-retry', data, config);
        return response;
    }
    async getSlipVerifyRetryMultiple(data) {
        const response = await axios.post(tenantUrl + '/v1/service/payment/slip-verify-retry-multiple', data, config);
        return response;
    }
}

class PaymentV2 {
    async getAllPayment(queryString = '') {
        return await axios.get(tenantUrl + '/v2/payments' + signature(queryString), config);
    }
    async getSalesUser(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/payments/sales-user' + signature(queryString), config);
        return response;
    }
    async deletePaymentTag(paymentId, tagId) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/payments/' + paymentId +"/tags/" + tagId + signature(), config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getOrder(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/payments/create/orders' + signature(queryString), config);
        return response;
    }
    async getPaymentsInfo(paymentsId, options = {}) {
        const response = await axios.get(tenantUrl + '/v2/payments/' + paymentsId + signature(), config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getBankAccount(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/payments/create' + signature(queryString), config);
        return response;
    }
    async getPaymentLogs(paymentsId, queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/payments/' + paymentsId + '/logs' + signature(queryString), config);
        return response;
    }
    async postAddTag(paymentId, data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/payments/' + paymentId + '/tags' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async updatePayment(paymentId, data) {
        const response = await axios.put(tenantUrl + '/v2/payments/' + paymentId + signature(), data, config);
        return response;
    }
}

class Upsell {
    async getCountTab(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/upsell/count-tab' + queryString, config);
    }

    async sumWon(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/upsell/sum-won' + queryString, config);
    }

    async getRequest(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/upsell/request', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getUpsellRequestType() {
        try{
            return await axios.get(tenantUrl + '/v1/service/upsell/request-type', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async postUpsell(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/upsell/' + orderId, data, config);
        return response;
    }

    async postUpsellFailed(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/upsell/upsellfailed/' + orderId, data, config);
        return response;
    }

    async postUpsellFollowup(orderId, data) {
        const response = await axios.post(tenantUrl + '/v1/service/upsell/upsellfollowup/' + orderId, data, config);
        return response;
    }

    async putUpsellReason(data) {
        const response = await axios.put(tenantUrl + '/v1/service/upsell/putupsellreason', data, config);
        return response;
    }

    async getUpsellReason(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/upsell/getupsellreason' + queryString, config);
        return response;
    }

    async putUpsellReverseOrder(data) {
        const response = await axios.put(tenantUrl + '/v1/service/upsell/reverse', data, config);
        return response;
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/upsell/setting', config);
        return response;
    }
}

class UpsellV2 {
    async getOrder(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/upsells' + signature(queryString), config);
        return response;
    }

    async getRequest() {
        const response = await axios.post(tenantUrl + '/v2/upsells/request' + signature(), '', config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async putUpsellReverseOrder(data) {
        const response = await axios.put(tenantUrl + '/v2/upsells/reverse' + signature(), data, config);
        return response;
    }

    async postUpsellStatus(upsellId, data) {
        const response = await axios.post(tenantUrl + '/v2/upsells/' + upsellId + '/status' + signature(), data, config);
        return response;
    }

}
class Gender {
    async getGender(options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/gender', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
}

class BuildingType {
    async getBuildingType(options = {}) {
        try{
            let response = await axios.get(tenantUrl + '/v1/service/building-type', config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}
class Integration {
    async getIntegrationView(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/integration/view' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }

    async getDocumentComplete() {

        return await axios.get(tenantUrl + '/v1/service/document/complete', config);

    }

    async getDocumentLast() {
        try{
            return await axios.get(tenantUrl + '/v1/service/document', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getIntegration(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/integration' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }

    async getIntegrationById(integrationId) {
        const response = await axios.get(tenantUrl + '/v1/service/integration/' + integrationId, config);
        return response;
    }
    async postIntegration(data) {
        const response = await axios.post(tenantUrl + '/v1/service/integration', data, config);
        return response;
    }
    async putIntegration(id, data) {
        const response = await axios.put(tenantUrl + '/v1/service/integration/' + id, data, config);;
        return response;
    }
    async deleteIntegration(id) {
        const response = await axios.delete(tenantUrl + '/v1/service/integration/' + id, config);;
        return response;
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/integration/use-setting', config);
        return response;
    }
    async sortIntegration(data) {
        return await axios.post(tenantUrl + '/v1/service/integration/sort-integrations', data, config);
    }

    async registerMarketplaces(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/marketplaces/register`, data, config);
    }

    async addSaleChannel(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/marketplaces/addchannel`, data, config);
    }

    async getIntegrationLogs(integrationId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/integration/' + integrationId + '/logs' + queryString, config);
    }

    async getMarketplaceLogs(integrationId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/integration/' + integrationId + '/logs' + queryString, config);
    }

    async syncOrder(integrationId) {
        return await axios.get(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/sync/order`, config);
    }

    async syncProduct(integrationId) {
        return await axios.get(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/sync/product`, config);
    }

    async disconnect(integrationId) {
        return await axios.put(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/disconnect`, config);
    }

    async enableSyncOrder(integrationId) {
        return await axios.put(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/enable-sync-order`, config);
    }

    async delete(integrationId) {
        return await axios.delete(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/delete`, config);
    }

    async getSyncMarketPlaceData(integrationId) {
        return await axios.get(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/getSyncMarketPlaceData`, config);
    }

    async registerSocial(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/registerApp`, data, config);
    }

    async getSocialPagesData(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/getPageData`, data, config);
    }

    async addSocialChannel(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/addSocialNetwork`, data, config);
    }

    async addMultiSocialChannel(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/gochat`, data, config);
    }

    async getAllSocialConnected() {
        return await axios.get(tenantUrl + `/v1/service/integration/gochat`, config);
    }

    async getSocialConnected(pageId) {
        return await axios.get(tenantUrl + `/v1/service/integration/gochat/${pageId}`, config);
    }

    async changeSocialAliasName(pageId, data) {
        return await axios.put(tenantUrl + `/v1/service/integration/gochat/${pageId}`, data, config);
    }

    async reauthorize(pageId, data) {
        return await axios.put(tenantUrl + `/v1/service/integration/gochat/${pageId}/reauthorize`, data, config);
    }

    async disconnectSocial(pageId, data) {
        return await axios.put(tenantUrl + `/v1/service/integration/gochat/${pageId}/disconnect`, data, config);
    }

    async deleteSocial(pageId) {
        return await axios.delete(tenantUrl + `/v1/service/integration/gochat/${pageId}`, config);
    }

    async autoLoginSocial(queryString) {
        return await axios.get(tenantUrl + `/v1/service/chat/auto-login` + queryString, config);
    }

    async getIntegrationByIdTrackman(integrationId) {
        const response = await axios.get(tenantUrl + `/v1/service/integration/${integrationId}/trackman`, config);
        return response;
    }

    async activateTrackman(integrationId, queryString='') {
        return await axios.put(tenantUrl + `/v1/service/integration/${integrationId}/trackman/activate` + queryString, config);
    }

    async logs(integrationId, queryString='') {
        return await axios.get(tenantUrl + `/v1/service/integration/${integrationId}/logs` + queryString, config);
    }

    async getStaffs(queryString='') {
        return await axios.get(tenantUrl + `/v1/service/integration/staffs` + queryString, config);
    }

    async checkCustomerCodeInterExpress(data) {
        return await axios.post(tenantUrl + `/v1/service/integration/carrier/check-customer-code`, data, config);
    }

    async editIntegration(integrationId, data = '') {
        return await axios.put(tenantUrl + `/v1/service/integration/marketplaces/${integrationId}/edit`, data, config);
    }
}

class IntegrationV2 {
    async getCheckAccount(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/integrations/voice-call/yalecom/check-account' + signature(queryString), config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err.response;
        }
    }
    async createYalecom(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/integrations/voice-call/yalecom' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getYalecomById(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/integrations/voice-call/yalecom/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async updateYalecom(id = null, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/voice-call/yalecom/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async deleteYalecom(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/integrations/voice-call/yalecom/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async testConnectErp(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/integrations/erp/' + id + '/test-connect' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async reTokenErp(id, data = {}) {
        try{
            const response = await axios.post(tenantUrl + '/v2/integrations/erp/' + id + '/re-token' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async registerEcommerceWebsite(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/integrations/ecommerce-website/register' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async deleteEcommerceWebsite(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/integrations/ecommerce-website/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async updateEcommerceWebsite(id = null, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/ecommerce-website/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async disconnectEcommerceWebsite(id, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/ecommerce-website/' + id + '/disconnect' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async enableSyncOrderEcommerceWebsite(id, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/ecommerce-website/' + id + '/enable-sync-order' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getEcommerceWebsite(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/integrations/ecommerce-website/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async activateFulfillment(id, data){
        try{
            const response = await axios.post(tenantUrl + '/v2/integrations/fulfillment/'+id+'/activate'+ signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async syncStockEcommerce(id = null, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/ecommerce-website/' + id + '/sync-stock' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getFulfillment(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/integrations/fulfillment/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async deleteFulfillment(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/integrations/fulfillment/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async syncStockMarketplaces(id = null, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/marketplaces/' + id + '/sync-stock' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postUpdateWarehouse(id, data = {}) {
      try{
          const response = await axios.put(tenantUrl + '/v2/integrations/' + id + '/warehouses' + signature(), data, config);
          return response;
      }catch (err) {
          return err.response;
      }
    }
    async updateMarketPlace(id = null, data = '') {
        try{
            const response = await axios.put(tenantUrl + '/v2/integrations/marketplaces/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async deleteMarketPlace(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/integrations/marketplaces/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
}

class IntegrationType {
    async getIntegrationType(integrationTypeId) {
        const response = await axios.get(tenantUrl + '/v1/service/integration-type', config);
        return response.data;
    }
    async getIntegrationTypeById(integrationTypeId) {
        return await axios.get(tenantUrl + '/v1/service/integration-type/' + integrationTypeId, config);
    }
    async getIntegrationTypeByGroupId(integrationGroupId) {
        try{
            return await axios.get(tenantUrl + '/v1/service/integration-group/' + integrationGroupId, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}
class PaymentMethod {
    async getPaymentMethodList(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/payment-method/list' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getPaymentMethod(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/payment-method' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    async setDefaultPaymentMethod(id, data) {
        return await axios.put(tenantUrl + '/v1/service/payment-method/' + id + '/setdefault', data, config);
    }
}

class Consignment {
    async getConsignment(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/consignment' + queryString, config);
        return response;
    }
    async getConsignmentById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/consignment/' + id, config);
        return response;
    }
    async postConsignment(data) {
        const response = await axios.post(tenantUrl + '/v1/service/consignment', data, config);
        return response;
    }
    async putConsignment(id, data) {
        const response = await axios.put(tenantUrl + '/v1/service/consignment/' + id, data, config);
        return response;
    }
    async getCheckDuplicateConsignment(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/consignment/check-duplicate' + queryString, config);
        return response;
    }
    async deleteConsignment(id) {
        const response = await axios.delete(tenantUrl + '/v1/service/consignment/' + id, config);
        return response;
    }
}

class Shipment {

    async getDocumentStatus() {
        return await axios.get(tenantUrl + '/v1/service/shipment/documentstatus', config)
    }

    async getDocumentStatusComplete() {
        return await axios.get(tenantUrl + '/v1/service/shipment/documentstatuscomplete', config)
    }

    async getShipment(queryString) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment' + queryString, config)
            return response;
        } catch (err) {
            if (err.response.status !== 403) { //pin
                handleApi(err);
            }

            return err.response;
        }
    }
    async getShipmentById(id) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/shipment/' + id, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getShipmentItem(shipmentId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/' + shipmentId + '/getshipmentitem', config)
    }
    async getStatusList(shipmentId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/' + shipmentId + '/statuslist', config)
    }
    async getActivityLogs(shipmentId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/' + shipmentId + '/activitylog', config)
    }
    async getActivityLogsShipment(shipmentId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/' + shipmentId + '/shipmentlog', config)
    }
    async getPickupList(queryString) {
        return await axios.get(tenantUrl + '/v1/service/shipment/pickuplist' + queryString, config)
    }
    async getVerifyAddress(queryString) {
        return await axios.get(tenantUrl + '/v1/service/shipment/verifyaddress' + queryString, config);
    }
    async getLocationpickup(locationTypeId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/locationpickup/' + locationTypeId, config);
    }
    async getCarrierCode(queryString) {
        return await axios.get(tenantUrl + '/v1/service/shipment/getcarriercode' + queryString, config);
    }
    async getShipmentView(shipmentId) {
        const response = await axios.get(tenantUrl + '/v1/service/shipment/' + shipmentId + '/shipmentview', config);
        return response;
    }
    async getPromotion(carrierId) {
        return await axios.get(tenantUrl + '/v1/service/shipment/promotion/' + carrierId, config);
    }
    async postShipmentList(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/list', data, config)
    }

    async getReadytoship(shipmentId) {
        let data = {};
        return await axios.post(tenantUrl + '/v1/service/shipment/' + shipmentId + '/get-readytoship', data, config)
    }

    async setReadytoship(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/set-readytoship', data, config)
    }

    async updateShippingInfo(shipmentId,data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/' + shipmentId + '/update-shipping-info', data, config)
    }

    async printShippingLabel(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/print-shipping-label', data, config)
    }

    async mergeShippingLabel(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/merge-shipping-label', data, config)
    }

    async trackProgress(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/track-progress', data, config)
    }

    async postRequestTracking(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/requesttracking', data, config);
        return response;
    }

    async postShipment(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment', data, config);
        return response;
    }

    async postCancelShipment(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/cancel', data, config);
        return response;
    }

    async postCancelPickup(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/cancelpickup', data, config);
        return response;
    }
    async postShipmentToShipped(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/toshipped', data, config);
        return response;
    }
    async postShipmentReadyToShip(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/toreadytoship', data, config);
        return response;
    }
    async postShipmentUndo(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/undo', data, config);
        return response;
    }

    async postSmsTracking(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/sendSmsTracking', data, config);
        return response;
    }

    async postPickup(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/pickup', data, config);
        return response;
    }

    async postShipmentEstimate(data) {
        try{
            return await axios.post(tenantUrl + '/v1/service/shipment/shipment-estimate', data, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async putCancelShipment(data) {
        const response = await axios.put(tenantUrl + '/v1/service/shipment/canceledShipment', data, config);
        return response;
    }
    async updateShipmentDestination(data) {
        const response = await axios.put(tenantUrl + '/v1/service/shipment/updateShipmentDestination', data, config);
        return response;
    }


    async updateUrlMap(shipmentId, data) {
        const response = await axios.put(tenantUrl + `/v1/service/shipment/${shipmentId}/url_map`, {data}, config);
        return response;
    }

    async updateTracking(shipmentId, data) {
        const response = await axios.put(tenantUrl + `/v1/service/shipment/${shipmentId}/tracking_no`, {data}, config);
        return response;
    }

    async getPaymentMethod(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/shipment/payment-method' + queryString, config);
    }
    async postInOrder(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipment/post-in-order', data, config);
        return response;
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/shipment/setting', config);
        return response;
    }

    async getIntegration(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/integration' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }

    async getChannel(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/channel' + queryString, config);
            return response.data;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }

    async getStore(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/store' + queryString, config);
            return response.data;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }
    async getDeliveryType(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/delivery-type' + queryString, config);
            return response.data;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }


    async postScanPacked(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/packed', data, config);
    }

    async getScanPacked(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/shipment/scan-packed' + queryString, config);
    }

    async getLocaltionShipping() {
      return await axios.get(tenantUrl + '/v1/service/shipment/localtionShipping', config);
    }

    async getRates() {
        return await axios.get(tenantUrl + '/v1/service/shipment/get-rates', config);
    }
    async getCombineOrdersList(queryString) {
      return await axios.get(tenantUrl + '/v1/service/shipment/combine-package-list/' + queryString, config)
    }

    async postCombineOrders(data) {
      return await axios.post(tenantUrl + '/v1/service/shipment/combine-package', data, config)
    }
    async editCombineOrders(data) {
      return await axios.post(tenantUrl + '/v1/service/shipment/combine-package-remove', data, config)
    }

    async changeCarrierList() {
        try {
            return await axios.get(tenantUrl + '/v1/service/shipment/change-carrier', config)
        } catch ({response}) {
            return response
        }
    }

    async getSellerOwnFleetList() {
        try {
            return await axios.get(tenantUrl + '/v1/service/shipment/seller-own-fleet', config)
        } catch ({response}) {
            return response
        }
    }

    async postSellerOwnFleetStatus(data) {
        return await axios.post(tenantUrl + '/v1/service/shipment/seller-own-fleet-status', data, config)
    }
}

class ShipmentV2 {
    async getShipment(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/shipments' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getShipmentById(id) {
        const response = await axios.get(tenantUrl + '/v2/shipments/' + id + signature(), config);
        return response;
    }

    async getActivityLogs(shipmentId) {
        return await axios.get(tenantUrl + '/v2/shipments/' + shipmentId + '/activities' + signature(), config)
    }

    async getLogsShipment(shipmentId) {
        return await axios.get(tenantUrl + '/v2/shipments/' + shipmentId + '/logs' + signature(), config)
    }

    async getStatusList(shipmentId) {
        return await axios.get(tenantUrl + '/v2/shipments/' + shipmentId + '/statuses' + signature(), config)
    }

    async validate(shipmentsId) {
        try {
            return await axios.post(tenantUrl + '/v2/shipments/validate' + signature(), shipmentsId, config)
        } catch ({response}) {
            return response
        }
    }

    async validateMarketplace(shipmentsId) {
        try {
            return await axios.post(tenantUrl + '/v2/shipments/marketplace-validate' + signature(), shipmentsId, config)
        } catch ({response}) {
            return response
        }
    }

    async validateFulfillment(shipmentsId) {
        return await axios.post(tenantUrl + '/v2/shipments/fulfillment-validate' + signature(), shipmentsId, config)
    }

    async changeCarrier(shipmentsId) {
        return await axios.post(tenantUrl + '/v2/shipments/carriers' + signature(), shipmentsId, config)
    }

    async requestUpdate(data='') {
        return await axios.post(tenantUrl + '/v2/shipments/batch/request-update' + signature(), data, config)
    }
    // Stock
    async getWarehouseList(queryString) {
        return await axios.get(tenantUrl + '/v2/shipments/stocks/warehouses' + signature(queryString), config)
    }
    async getValidateStock(data) {
        return await axios.post(tenantUrl + '/v2/shipments/stocks/validate' + signature(), data, config)
    }
    async moveReadyToShipWithStocks(data) {
        return await axios.post(tenantUrl + '/v2/shipments/stocks/move-ready-to-ship' + signature(), data, config)
    }
    async getStockShipmentValidate(data) {
        return await axios.post(tenantUrl + '/v2/shipments/stocks/shipment-validate' + signature(), data, config)
    }
    async getProductSetByOmniLinks(data) {
        return await axios.post(tenantUrl + '/v2/shipments/stocks/product-sets' + signature(), data, config)
    }
    async postRetrySendFulfillment(data) {
        return await axios.post(tenantUrl + '/v2/shipments/batch/send-fulfillment' + signature(), data, config)
    }

    async getSplitShipmentById(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/shipments/' + id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postSplitShipments(data ='') {
        try{
            const response = await axios.post(tenantUrl + '/v2/shipments/split' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postUnSplitShipments(data ='') {
        try{
            const response = await axios.post(tenantUrl + '/v2/shipments/unsplit' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getUnSplitShipmentInfo(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/shipments/' + id + '/unsplit' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getScanPacked(queryString = '') {
      return await axios.get(tenantUrl + '/v2/shipments/scan-pack/info' + signature(queryString), config);
    }
    async postScanPacked(data) {
      return await axios.post(tenantUrl + '/v2/shipments/scan-pack' + signature(), data, config);
    }
}

class AiSlip {
    async postAiSlip(data) {
        const response = await axios.post(tenantUrl + '/v1/service/ai-slip', data, config);
        return response;
    }
}
class Location {
    async getLocation(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/location' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getLocationById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/location/' + id, config);
        return response;
    }
    async getLocationByIntegrationtype(id) {
        return await axios.get(tenantUrl + '/v1/service/location/' + id + '/integrationtype', config);
    }
    async postLocation(data) {
        return await axios.post(tenantUrl + '/v1/service/location', data, config);
    }
    async putLocation(id, data) {
        return await axios.put(tenantUrl + '/v1/service/location/' + id, data, config);;
    }
    async putLocationDefault(id, data) {
        return await axios.put(tenantUrl + '/v1/service/location/' + id + '/setdefault', data, config);;
    }
    async deleteLocation(id) {
        return await axios.delete(tenantUrl + '/v1/service/location/' + id, config);
    }
    async getAutoCompleteAddress(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/location/auto-complete-address' + queryString, config);
    }
}
class LocationType {
    async getLocationType(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/locations-type' + queryString, config);
    }
}
class LocationDefault {
    async getLocationDefault(queryString) {
        return await axios.get(tenantUrl + '/v1/service/location-default' + queryString, config);
    }
}

class Media {
    async getMedia() {
        return await axios.get(tenantUrl + '/v1/service/media', config);
    }
    async getMediaById(id) {
        return await axios.get(tenantUrl + '/v1/service/media' + id, config);
    }
    async postMedia(data) {
        const response = await axios.post(tenantUrl + '/v1/service/media/create', data, config);
        return response;
    }
    async deletePack(data) {
        try {
            const response = await axios.put(tenantUrl + '/v1/service/product-media/delete_pack', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getImageGoPayPath(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/media/gopay-image' + queryString, config);
    }
}

class Setting {

    async getIntegration(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/setting/integration' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getBusinessInfo() {
        const response = await axios.get(tenantUrl + '/v1/service/setting/info', config);
        return response;
    }

    async getBusinessInfoList() {
        const response = await axios.get(tenantUrl + '/v1/service/setting', config);
        return response;
    }

    async getBusinessInfoListTopMenu() {
        return await axios.get(tenantUrl + '/v1/service/setting/topmenu', config);
    }

    async getSettingPayment() {
        return await axios.get(tenantUrl + '/v1/service/setting/payments', config);
    }

    async putSettingPayment(data) {
        return await axios.put(tenantUrl + '/v1/service/setting/payments', data, config);
    }

    async postBusinessInfo(data) {
        const response = axios.post(tenantUrl + '/v1/service/setting/create', data, config);
        return response;
    }
    async putBusinessInfo(id, data) {
        const response = axios.put(tenantUrl + '/v1/service/setting/update/' + id, data, config);
        return response;
    }
    async putSettingField(id, field, data) {
        return await axios.put(tenantUrl + `/v1/service/setting/update/${field}/${id}`, data, config);
    }
    async getLabel() {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-label', config);
        return response;
    }
    async getSaleContactAdvance(id) {
        try{
            return await axios.get(tenantUrl + '/v1/service/setting/sale-contact/getAdvance/' + id, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getSettingUpsell(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/setting/upsell', config);
        } catch (err) {
            return err.response;
        }
    }
    async putSettingUpsell(data) {
        return await axios.put(tenantUrl + '/v1/service/setting/upsell', data, config);
    }
    async patchDisableUpsell(id, status) {
        return await axios.patch(tenantUrl + '/v1/service/setting/patchUpsell/' + id, status, config);
    }
    async postSaleContact(data) {
        const response = axios.post(tenantUrl + '/v1/service/setting/sale-contact', data, config);
        return response;
    }
    async putSaleContact(data, id) {
        const response = axios.put(tenantUrl + '/v1/service/setting/sale-contact/' + id, data, config);
        return response;
    }
    async deleteSaleContact(id) {
        const response = axios.delete(tenantUrl + '/v1/service/setting/sale-contact/' + id, config);
        return response;
    }
    async putSaleContactAdvance(id, status) {
        const response = axios.put(tenantUrl + '/v1/service/setting/sale-contact/advance/' + id, status, config);
        return response;
    }


    async getUser(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/getuser' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getUserProductAssign(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/getuserproductassign' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getProduct(queryString) {
        return await axios.get(tenantUrl + '/v1/service/setting/getproduct' + queryString, config);
    }

    async getUpsellPeriodType(options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/setting/upsellperiodtype', config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getUpsellProductAssign(queryString = '', options = {}) {
        try{
            return await axios.get(tenantUrl + '/v1/service/setting/upsellproductassign' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getUpsellProductAssignByProductId(productId = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/upsellproductassign/' + productId, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postUpsellproductassign(data) {
        try {
            return await axios.post(tenantUrl + '/v1/service/setting/upsellproductassign', data, config);
        } catch (err) {
            return err.response;
        }
    }

    async putUpsellproductassign(productId = '', data) {
        return await axios.put(tenantUrl + '/v1/service/setting/upsellproductassign/' + productId, data, config);
    }

    async deleteUpsellproductassign(productId = '') {
        return await axios.delete(tenantUrl + '/v1/service/setting/upsellproductassign/' + productId, config);
    }

    async getIntegrationType(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/setting/sale-contact/integrationtype' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getIntegrationSaleContact(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/getintegrationsalecontact' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getSalepage(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/getsalepage' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getOrderNotifyType(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/order-notify-type' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getOrderNotify(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/order-notify' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postOrderNotify(data) {
        return await axios.post(tenantUrl + '/v1/service/setting/order-notify', data, config);
    }

    async getOrderNotifyByOrderNotifytId(orderNotifytId, options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/notify/line/' + orderNotifytId, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async putOrderNotify(orderNotifytId, data) {
        return await axios.put(tenantUrl + '/v1/service/setting/order-notify/' + orderNotifytId, data, config);
    }

    async deleteOrderNotify(orderNotifytId) {
        return await axios.delete(tenantUrl + '/v1/service/setting/order-notify/' + orderNotifytId, config);
    }

    async getOrderNotifyIntegrationNotUse(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/order-notify/order-notify-integration-not-use' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async orderNotifySalepageNotUse(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/order-notify/order-notify-salepage-not-use' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getOrderNotifyBasic(options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/setting/order-notify/get-order-notify-basic', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async listNotify(queryString, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/setting/notify' + queryString, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async deleteLineNotifyById(id) {
        return await axios.delete(tenantUrl + '/v1/service/setting/notify/line/' + id, config);
    }

    async putLineNotifyById(id, data) {
        return await axios.put(tenantUrl + '/v1/service/setting/notify/line/' + id, data, config);
    }

    async deleteLineNotify(queryString) {
        return await axios.delete(tenantUrl + '/v1/service/setting/notify/line' + queryString, config);
    }

    async getTemplate(queryString) {
      return await axios.get(tenantUrl + '/v1/service/template' + queryString, config);
    }

    async getTemplateEdit(queryString) {
      return await axios.get(tenantUrl + '/v1/service/template/edit' + queryString, config);
    }

    async putTemplate(id, data) {
        return await axios.put(tenantUrl + '/v1/service/template/' + id, data, config);
    }

    async getSettingLog(settingId, queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/setting/' + settingId + '/logs' + queryString, config);
    }



}

class SettingV2 {
  async getSettingAccountingTaxes(queryString = '') {
    try{
      const response = await axios.get(tenantUrl + '/v2/settings/accounting/taxes' + signature(queryString), config);
      return response;
    } catch (err) {
      return err.response;
    }
  }

  async putSettingAccountingTaxes(id, data = {}) {
    try{
        const response = await axios.put(tenantUrl + '/v2/settings/accounting/taxes/' + id + signature(), data, config);
        return response;
    }catch (err) {
        return err.response;
    }
  }

  async getSettingAccountingInvoice(queryString = '') {
    try{
      const response = await axios.get(tenantUrl + '/v2/settings/accounting/invoice' + signature(queryString), config);
      return response;
    } catch (err) {
      return err.response;
    }
  }

  async putSettingAccountingInvoice(id, data = {}) {
    try{
        const response = await axios.put(tenantUrl + '/v2/settings/accounting/invoice/' + id + signature(), data, config);
        return response;
    }catch (err) {
        return err.response;
    }
  }

  async getSettingAccountingLogs(settingId, queryString = '') {
    const response = await axios.get(tenantUrl + '/v2/settings/accounting/' + settingId + '/logs' + signature(queryString), config);
    return response;
  }

  async getSettingUpsell(queryString = '') {
    const response = await axios.get(tenantUrl + '/v2/settings/upsells' + signature(queryString), config);
    return response;
  }

  async putSettingUpsell(settingId, data) {
    const response = await axios.put(tenantUrl + '/v2/settings/upsells/' + settingId + signature(), data, config);
    return response;
  }

  async getSettingUpsellLogs(settingId, queryString = '') {
    const response = await axios.get(tenantUrl + '/v2/settings/upsells/' + settingId + '/logs' + signature(queryString), config);
    return response;
  }

  async putUpsellDisable(data) {
    const response = await axios.put(tenantUrl + '/v2/settings/upsell-disable' + signature(), data, config);
    return response;
  }

  async getSettingsInventory() {
    const response = await axios.get(tenantUrl + '/v2/settings/inventories'+signature(),config);
    return response;
  }

  async updateSettingsInventory(warehouseId = null,data='') {
    const response = await axios.put(tenantUrl + '/v2/settings/inventories'+ signature(), data, config);
    return response;
  }

  async getSalesOrderMessageTemplateEdit(queryString = '') {
    const response = await axios.get(tenantUrl + '/v2/settings/message-template/order-draft/edit' + signature(queryString), config);
    return response;
  }

  async getSettingOrderManagement(queryString = '') {
    const response = await axios.get(tenantUrl + '/v2/settings/order-management' + signature(queryString), config);
    return response;
  }

  async updateSettingOrderManagement(data='') {
    try{
        const response = await axios.put(tenantUrl + '/v2/settings/order-management' + signature(),data , config);
        return response;
    } catch (err) {
        return err.response;
    }
  }

  async updateSettingOrderDuplicateManagement(data='') {
    try{
        const response = await axios.put(tenantUrl + '/v2/settings/order-management/duplicate-order' + signature(), data, config);
        return response;
    } catch (err) {
        return err.response;
    }
  }

  async putSalesOrderMessageTemplate(data) {
    const response = await axios.put(tenantUrl + '/v2/settings/message-template/order-draft'+ signature(), data, config);
    return response;
  }

  async getIntegrationConfig(queryString) {
    const response = await axios.get(tenantUrl + '/v2/settings/inventories/specific-warehouses/integrations' + signature(queryString),config);
    return response;
  }

  async getIntegrationProductLinkConfig(queryString) {
    const response = await axios.get(tenantUrl + '/v2/settings/inventories/specific-warehouses/product-links' + signature(queryString),config);
    return response;
  }

  async postIntegrationSetting(data) {
    const response = await axios.post(tenantUrl + '/v2/settings/inventories/specific-warehouses'+ signature(), data, config);
    return response;
  }

    async getNotifyOrderList(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/order' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postNotifyOrderCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/settings/notify/order' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyOrderCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/order/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyOrderEnable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/order/enable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyOrderDisable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/order/disable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async deleteNotifyOrder(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/settings/notify/order/' + id  + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyOrderEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/order/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyOrderEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/order/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getNotifyShipmentList(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/shipment' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postNotifyShipmentCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/settings/notify/shipment' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyShipmentCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/shipment/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyShipmentEnable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/shipment/enable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyShipmentDisable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/shipment/disable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async deleteNotifyShipment(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/settings/notify/shipment/' + id  + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyShipmentEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/shipment/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyShipmentEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/shipment/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getNotifyUpsellList(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/upsell' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postNotifyUpsellCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/settings/notify/upsell' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyUpsellCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/upsell/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyUpsellEnable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/upsell/enable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyUpsellDisable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/upsell/disable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async deleteNotifyUpsell(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/settings/notify/upsell/' + id  + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyUpsellEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/upsell/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyUpsellEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/upsell/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getNotifyCodList(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/cod' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postNotifyCodCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/settings/notify/cod' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyCodCreate(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/cod/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyCodEnable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/cod/enable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyCodDisable(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/cod/disable' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async deleteNotifyCod(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/settings/notify/cod/' + id  + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getNotifyCodEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/settings/notify/cod/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putNotifyCodEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/settings/notify/cod/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getSignatureQuotationDefault(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/quotation' + signature(queryString), config);
        return response;
    }

    async postSignatureQuotationDefault(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/quotation' + signature(),data, config);
        return response;
    }

    async putSignatureQuotationDefault(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/quotation/' + id + signature(), data, config);
        return response;
    }

    async getSignaturePurchaseOrder(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/purchase-order' + signature(queryString), config);
        return response;
    }

    async postSignaturePurchaseOrder(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/purchase-order' + signature(),data, config);
        return response;
    }

    async putSignaturePurchaseOrder(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/purchase-order/' + id + signature(), data, config);
        return response;
    }

    async getSignatureReceipts(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/receipts' + signature(queryString), config);
        return response;
    }

    async postSignatureReceipts(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/receipts' + signature(),data, config);
        return response;
    }

    async putSignatureReceipts(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/receipts/' + id + signature(), data, config);
        return response;
    }

    async getSignatureDelivery(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/delivery' + signature(queryString), config);
        return response;
    }

    async postSignatureDelivery(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/delivery' + signature(),data, config);
        return response;
    }

    async putSignatureDelivery(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/delivery/' + id + signature(), data, config);
        return response;
    }

    async getSignaturePickingList(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/picking-list' + signature(queryString), config);
        return response;
    }

    async postSignaturePickingList(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/picking-list' + signature(),data, config);
        return response;
    }

    async putSignaturePickingList(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/picking-list/' + id + signature(), data, config);
        return response;
    }

    async getSignatureDeliveryProof(queryString) {
        const response = await axios.get(tenantUrl + '/v2/settings/signature/delivery-proof' + signature(queryString), config);
        return response;
    }

    async postSignatureDeliveryProof(data) {
        const response = await axios.post(tenantUrl + '/v2/settings/signature/delivery-proof' + signature(),data, config);
        return response;
    }

    async putSignatureDeliveryProof(id, data = {}) {
        const response = await axios.put(tenantUrl + '/v2/settings/signature/delivery-proof/' + id + signature(), data, config);
        return response;
    }
}

class ShippingLabel {

    async getLabel() {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-label', config);
        return response;
    }

    async postPrintLabel(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipping-label/print-label', data, config);
        return response;
    }
    async postSettingDefualt(data) {
        const response = await axios.post(tenantUrl + '/v1/service/shipping-label/setting-defualt', data, config);
        return response;
    }
}

class Label {

    async getLabel(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/label' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                // handleApi(err);
            }
            return err;
        }
    }

    async getIntegration(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/label/integration' + queryString, config);
    }

    async getLabelById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/label/' + id, config);
        return response;
    }

    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/label/' + id, data, config);
        return response;
    }

    async checkLabel(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/label/checkLabel' + queryString, config);
    }

}

class Receipt {
    async getReceipt(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/receipts' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postPrintReceipt(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/receipts', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getReceiptById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/receipts/' + id, config);
        return response;
    }


    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/receipts/' + id, data, config);
        return response;
    }
}

class DeliveryOrder {
    async getDeliveryOrder(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/delivery' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postPrintDeliveryOrder(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/delivery', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getDeliveryOrderById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/delivery/' + id, config);
        return response;
    }

    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/delivery/' + id, data, config);
        return response;
    }
}

class TaxInvoice {
    async getTaxInvoice(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/tax-invoices' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postPrintTaxInvoice(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/tax-invoices', data, {
                headers: {
                    Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                // responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
            });
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postReceiptPrintTaxInvoice(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/receipt-tax-invoices', data, {
                headers: {
                    Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    Accept: 'application/json, text/plain, */*'
                },
            });
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postReceiptPrintTaxInvoiceAbb(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/receipts-abb', data, {
                headers: {
                    Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    Accept: 'application/json, text/plain, */*'
                },
            });
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postDeliveryPrintTaxInvoice(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/delivery-tax-invoices', data, {
                headers: {
                    Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                // responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
            });
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postDeliveryPrintReceiptTaxInvoice(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/delivery-receipts-tax-invoices', data, {
                headers: {
                    Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                // responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
            });
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getTaxInvoiceById(id) {
        const response = await axios.get(tenantUrl + '/v1/service/tax-invoices/' + id, config);
        return response;
    }

    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/tax-invoices/' + id, data, config);
        return response;
    }
}

class PickingList {
    async getPickingListType() {
        try{
            return  await axios.get(tenantUrl + '/v1/service/picking-list-type', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getPickingList(queryString = '') {
        try{
            return  await axios.get(tenantUrl + '/v1/service/picking-list' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/picking-list-default/' + id, data, config);
        return response;
    }
    async updateSetting(id, data) {
        const response = await axios.put(tenantUrl + '/v1/service/picking-list/' + id, data, config);
        return response;
    }
}

class DeliveryProof {
    async getDeliveryProofType() {
        const response = await axios.get(tenantUrl + '/v1/service/delivery-proof-type', config);
        return response;
    }
    async getDeliveryProof(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/delivery-proof' + queryString, config);
        return response;
    }
    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/delivery-proof-default/' + id, data, config);
        return response;
    }
}

class PurchaseOrder {
    async getPurchaseOrderType() {
        const response = await axios.get(tenantUrl + '/v1/service/purchase-order-type', config);
        return response;
    }
    async getPurchaseOrder(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/purchase-order' + queryString, config);
        return response;
    }
    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/purchase-order-default/' + id, data, config);
        return response;
    }
}
class Quotation {
    async getQuotationType() {
        const response = await axios.get(tenantUrl + '/v1/service/quotation-type', config);
        return response;
    }
    async getQuotation(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/quotation' + queryString, config);
        return response;
    }
    async putSettingDefualt(id, data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.put(tenantUrl + '/v1/service/quotation-default/' + id, data, config);
        return response;
    }
}

class FlatRate {
    async getFlatRate(queryString = '', options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/flat-rate' + queryString, config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getIntegrationById(integrationId) {
        try{
            return await axios.get(tenantUrl + '/v1/service/flat-rate/integration/' + integrationId, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async putFlatRate(id, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/flat-rate/' + id, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
}

class ShippingRate{
    async getShippingRate(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-rate' + queryString, config);
        return response.data.data;
    }

    async setDefaultShippingRate(id, data) {
        return await axios.put(tenantUrl + '/v1/service/shipping-rate/' + id + '/set-default', data, config);
    }
}

class ShippingRateItem{
    async getShippingRateItem(id, queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-rate-item/getbyid/' + id + queryString, config);
        return response.data.data;
    }

    async getShippingRateItemByDefault(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-rate-item/by-default' + queryString, config);
        return response.data.data;
    }

    async getShippingRateItemByDefaultSellerOwnFleet(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-rate-item/by-default-seller-own-fleet' + queryString, config);
        return response.data.data;
    }

    async setDefaultShippingRateItem(id, data) {
        return await axios.put(tenantUrl + '/v1/service/shipping-rate-item/' + id + '/set-default', data, config);
    }

    async checkSalepageIntegrationUsed(id, data = {}) {
        const response = await axios.post(tenantUrl +'/v1/service/shipping-rate-item/' + id + '/checkSalepageIntegrationUsed', data, config);
        return response
        // return await axios.post(tenantUrl + '/v1/service/shipping-rate-item/' + id + '/checkSalepageIntegrationUsed', config);
    }
}

class ShippingRateItemRow{
    async getShippingRateItemRow(id) {
        const response = await axios.get(tenantUrl + '/v1/service/shipping-rate-item-row/getbyid/' + id, config);
        return response.data.data;
    }

    async putShippingRateItemRow(id, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/shipping-rate-item-row/' + id, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postShippingRateItemRow(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/shipping-rate-item-row', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async deleteShippingRateItemRow(id) {
        return await axios.delete(tenantUrl + '/v1/service/shipping-rate-item-row/' + id, config);
    }

    async checkShippingRateIsDefault(id) {
        return await axios.get(tenantUrl + '/v1/service/shipping-rate-item-row/' + id + '/checkShippingRateIsDefault', config);
    }

}

class Address {
    async geCheckRemoteArea(integrationTypeId, address, type = '') {
        var params = {
            type: type,
            // integrationTypeId: integrationTypeId,
            integration_type_id: integrationTypeId,
            postcode: address.postcode,
            county: address.county
        };
        return await axios.get(tenantUrl + '/v1/service/shipment/check-remote-area', { params: params, headers: config.headers });
    }

    async spreadAddress(text) {
        const endpoint = `${tenantUrl}/v1/service/spread-address`;
        return await axios.get(endpoint, { params: { text }, headers: config.headers });
    }
}

class Industry {
    async getIndustry() {
        try{
            return await axios.get(tenantUrl + '/v1/service/industry', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}

class Dashboard {
    async getDashboard(queryString) {
        try{
            return await axios.get(tenantUrl + '/v1/service/dashboard' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getDashboardV2(queryString='') {
        try{
        const response = await axios.get(tenantUrl + '/v2/dashboard' + signature(queryString), config);
        return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async putDashboardCustomizeTopSales(data) {
        return await axios.put(tenantUrl + '/v2/dashboard/customize/top-sales'+ signature(), data, config);
    }
}

class Wallet {
    async getBalance(type) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/getbalance/' + type, config);
    }

    async getCreditStatus(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/getcreditstatus' + queryString, config);
    }
    async getSmsStatus(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/getsmsstatus' + queryString, config);
    }

    async getCreditTransaction(queryString) {
        //queryString += '&date_range=' + '20210901-20311231';
        //queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/shipment' + queryString, config);
    }

    async getBillingTransaction(queryString) {
        // queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/billing' + queryString, config);
    }

    async getCreditTransection(queryString) {
        //queryString += '&date_range=' + '20210901-20311231';
        //queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/shipment' + queryString, config);
    }

    async getBillingTransection(queryString) {
        // queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/billing' + queryString, config);
    }

    async getShippingBillingHistory(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/shippingbillinghistory' + queryString, config);
    }

    async getShippingBillingTransaction(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/shippingbillingtransaction' + queryString, config);
    }

    async getSmsBillingHistory(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/smsbillinghistory' + queryString, config);
    }

    async getSmsBillingTransaction(queryString) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/smsbillingtransaction' + queryString, config);
    }

    async getSmsTransection(queryString) {
        // queryString += '&date_range=' + '20210901-20311231';
        //queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/sms' + queryString, config);

    }

    async getBillingSmsTransection(queryString) {
        // queryString += '&date_range=' + '20210901-20311231';
        //queryString += '&date_range=' + '' + moment().subtract(3, "days").startOf('days').format('YYYYMMDD') + '-' + moment().add(1, "days").endOf('days').format('YYYYMMDD') + '';
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/billingsms' + queryString, config);
    }

    async getCarrier() {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/getcarrier', config);
    }


    async fetchSmsPackages() {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/getsmspackage', config);
    }

    async getTransactionView(orderId = null) {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/transaction/billing/view/' + orderId, config);
    }

    async addCredit(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/wallet/addcredit', data, config);
        return response;
    }

    async addSms(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/addsms', data, config);
        return response;
    }

    async addCreditCard(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/addcreditcard', data, config);
        return response;
    }

    async addPayment(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/addpayment', data, config);
        return response;
    }

    async addQrcode(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/addqrcode', data, config);
        return response;
    }

    async addSaleOrderBilling(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/addsaleorderbilling', data, config);
        return response;
    }

    async checkAddApprovement(data) {
        return await axios.post(tenantUrl + '/v1/service/merchant/wallet/checkaddapprovement', data, config);
    }

    async newWalletAddCredit(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/wallet/newWalletAddCredit', data, config);
        return response;
    }

    async newWalletAddSms(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/payment/newWalletAddSms', data, config);
        return response;
    }
    // const response = await axios.post(tenantUrl + '/v1/service/shipment/verifywallet',data, config);
    // return response;
}
class Merchant {
    async getInfo() {
        try{
            return await axios.get(tenantUrl + '/v1/service/merchant/getinfo', config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async updateActiveWallet(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/verifywallet', data, config);
        return response;
    }

    async member(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/member', data, config);
        return response;
    }

    async generateVerifyLink(data) {
        const response = await axios.post(tenantUrl + '/v1/service/merchant/generate-verify-link', data, config);
        return response;
    }

    async getBankCarrierCod(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/merchant/bank-carrier-cod' + queryString, config);
    }

    async putBankCarrierCod(id, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/merchant/bank-carrier-cod/' + id, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
}

class Module {
    async getModule() {
        return await axios.get(tenantUrl + '/v1/service/module', config);
    }
}

//Report
class Report {
    async getProductBestseller(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/reports/products/ReportBestSeller' + queryString, config);
    }

    async getSalesOrderTotalPayments(queryString = '') {
        if (queryString != '') {
            queryString = '?' + queryString;
        }
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportTotalPayments' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getSalesOrderDailyPayments(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportTotalDailyPayments' + queryString, config);
    }

    async getSalesOrderDailyPaymentsDetail(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportDailyPaymentsDetail' + queryString, config);
    }

    async getCodReconcile(queryString) {
        return await axios.get(tenantUrl + '/v1/service/reports/payment/ReportCashOnDelivery' + queryString, config);
    }

    async getCodOverViews(queryString) {
        const response = await axios.get(tenantUrl + '/v1/service/reports/payment/ReportCashOnDeliveryOverViews' + queryString, config);
        return response.data;
    }

    async getCodReconcileView(queryString, id, cod_account_id) {
        return await axios.get(tenantUrl + `/v1/service/reports/payment/ReportCashOnDelivery/${id}/${cod_account_id}${queryString}`, config);
    }

    async getCodReconcileOverViews(id, cod_account_id) {
        const response = await axios.get(tenantUrl + '/v1/service/reports/payment/paymentCodReportOverViews/' + id + '/' + cod_account_id, config);
        return response.data;
    }

    async getSalesOrderTotalSales(queryString = '') {
        if (queryString != '') {
            queryString = '?' + queryString;
        }
        return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportTotalSales' + queryString, config);
    }

    async getSalesOrderTotalSalesTable(queryString = '') {
        if (queryString != '') {
            queryString = '?' + queryString;
        }
        return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportTotalSalesTable' + queryString, config);
    }

    async getGroupSalesOrderPayment(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportGroupSalesOrderPayment' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getSalesOrderUpsell(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/ReportTotalSalesOrderUpsell' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    //Report ShippingExpenses
    async getShippingExpenses(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/reports/payment/ShippingExpenses' + queryString, config);
    }

    async getShippingExpensesTable(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/reports/payment/ShippingExpensesTable' + queryString, config);
    }

    async getShippingExpensesDetail(queryString, id) {
        return await axios.get(tenantUrl + '/v1/service/reports/payment/ShippingExpensesDetail/' + id + queryString, config);
    }

    async getShippingExpensesOverViews(queryString, id) {
        const response = await axios.get(tenantUrl + '/v1/service/reports/payment/ShippingExpensesOverViews/' + id + queryString, config);
        return response.data;
    }
    //sales report by province
    async getSalesReportByProvince(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/SalesReportByProvince' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getSalesReportByProvinceTable(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/SalesReportByProvinceTable' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getSalepage(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/orders/SalesReportBySalepage' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }

    async getShippingCreditReport(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/report/shippingcreditreport' + queryString, config);
    }

    async getSmsCreditReport(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/report/smscreditreport' + queryString, config);
    }
    //   returned Report
    async returnedParcelReport(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/products/ReportReturned' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    //Product Sales Report
    async getProductSalesGoship(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/products/ProductSalesReportGoship' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    async getProductSalesGosell(queryString = '') {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/products/ProductSalesReportGosell' + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    async getProductSalesDetailGoship(queryString, id) {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/products/ProductSalesReportGoshipDetail/' + id + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    async getProductSalesDetailGosell(queryString, id) {
        try {
            return await axios.get(tenantUrl + '/v1/service/reports/products/ProductSalesReportGosellDetail/' + id + queryString, config);
        } catch (err) {
            return err.response;
        }
    }
    async getIntegration(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/reports/integration' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }
    async getServicecreditreport(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/merchant/wallet/report/servicecreditreport' + queryString, config);
    }
}

class ReportV2 {
    async getCallHistory(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/voice-calls/history' + signature(queryString), config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err.response;
        }
    }
    async getCallHistoryDetails(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/voice-calls/history/' + id + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getShippingChargeBilling(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/shipping-charge-billing' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getShippingChargeBillingDetail(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/shipping-charge-billing/detail' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getShippingChargeBillingDetailDownload(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/shipping-charge-billing/download' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getShippingCreditReport(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/credit/shipping' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getSmsCreditReport(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/credit/sms' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getOrderSaleByChannelReport(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/sales-order-by-channel' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductSaleByCategoryReport(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/reports/product/sales-by-category' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class Import {
    async postImport(data) {
        const response = axios.post(tenantUrl + '/v1/service/import/upload', data, config);
        return response;
    }
    async getImportByID(id) {
        try{
            return axios.get(tenantUrl + '/v1/service/import/' + id, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async postImportConfirmCodReceived(data) {
        const response = axios.post(tenantUrl + '/v1/service/import/confirm-cod', data, config);
        return response;
    }
    async getImportType(queryString = '') {
        const response = axios.get(tenantUrl + '/v1/service/import/importType' + queryString, config);
        return response;
    }
    async getImport(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v1/service/import' + queryString, config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
    async getImportLog(id) {
        const response = axios.get(tenantUrl +  '/v1/service/import/' + id + '/importLog', config);
        return response;
    }

    async saveLogImport(data){
        const response = axios.post(tenantUrl + '/v1/service/import/save-log-import', data, config);
        return response;
    }

    async getImportConfirmCodReceivedLogs(id) {
        const response = axios.get(tenantUrl + '/v1/service/import/' + id + '/import-logs', config);
        return response;
    }
    async getImportTemplate(queryString = '') {
        const response = await axios.get(tenantUrl + '/v1/service/import/template' + queryString, config);
        return response;
    }
}

class ImportV2 {
    async getImport(queryString = '') {
        try{
            return await axios.get(tenantUrl + '/v2/imports/orders' + signature(queryString), config);
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}

class Export {
    async postOrder(data) {
        return await axios.post(tenantUrl + '/v1/service/order/export-excel', data, config);
    }
}

class ExportV2 {
    async getOrder(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/exports/orders' + signature(queryString), config);
        return response;
    }
    async getOrderCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/orders/create' + signature(), config);
        return response;
    }
    async postOrder(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/orders' + signature(), data, config);
        return response;
    }
    async getOrderInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/orders/' + id + signature(), config);
        return response;
    }
    async getOrderLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/orders/' + id + '/logs' + signature(), config);
        return response;
    }
    async getOrderFile(id, fileName) {
        const response = await axios.get(tenantUrl + '/v2/exports/orders/' + id + '/files/' + fileName + signature(), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
        });
        return response;
    }

    async getCustomer(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v2/exports/customers' + signature(queryString), config);
            return response;;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }async getCustomerInfo(id) {
        try {
            const response = await axios.get(tenantUrl + '/v2/exports/customers/' + id + signature(), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getCustomerCreate(queryString = '') {
        try {
            const response = await axios.get(tenantUrl + '/v2/exports/customers/create' + signature(queryString), config);
        return response;;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async postCustomerCreate(data = '') {
        try {
            const response = await axios.post(tenantUrl + '/v2/exports/customers' + signature(),data, config);
        return response;;
        } catch (err) {
            return err.response;
        }
    }
    async getCustomerFile(id, fileName) {
        try {
        const response = await axios.get(tenantUrl + '/v2/exports/customers/' + id + '/files/' + fileName + signature(), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
        });
        return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getCustomerActivityLog(customerId, queryString){
        try{
            const response = await axios.get(tenantUrl + '/v2/exports/customers/' + customerId + '/logs' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    // product

    async getProduct(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/exports/products' + signature(queryString), config);
        return response;
    }

    async postProduct(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/products' + signature(), data, config);
        return response;
    }

    async getProductCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/products/create' + signature(), config);
        return response;
    }

    async getProductInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/products/' + id + signature(), config);
        return response;
    }

    async getProductLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/products/' + id + '/logs' + signature(), config);
        return response;
    }

    async getProductFile(id, fileName) {
        const response = await axios.get(tenantUrl + '/v2/exports/products/' + id + '/files/' + fileName + signature(), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
        });
        return response;
    }

    // end product

    // stock balanace
    async getStockBalance(queryString = '') {
      const response = await axios.get(tenantUrl + '/v2/exports/stock-balance' + signature(queryString), config);
      return response;
    }
    async getStockBalanceCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-balance/create' + signature(), config);
        return response;
    }
    async postStockBalance(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/stock-balance' + signature(), data, config);
        return response;
    }
    async getStockBalanceInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-balance/' + id + signature(), config);
        return response;
    }
    async getStockBalanceLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-balance/' + id + '/logs' + signature(), config);
        return response;
    }
    async getStockBalanceFile(id, fileName) {
      const response = await axios.get(tenantUrl + '/v2/exports/stock-balance/' + id + '/files/' + fileName + signature(), {
          headers: {
              Authorization: 'Bearer ' + ACCESS_TOKEN.token,
              TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
      });
      return response;
    }
  // end stock balanace

    // product link
    async getProductLink(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/exports/product-link' + signature(queryString), config);
        return response;
    }

    async postProductLink(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/product-link' + signature(), data, config);
        return response;
    }

    async getProductLinkCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/product-link/create' + signature(), config);
        return response;
    }

    async getProductLinkInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/product-link/' + id + signature(), config);
        return response;
    }

    async getProductLinkLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/product-link/' + id + '/logs' + signature(), config);
        return response;
    }

    async getProductLinkFile(id, fileName) {
        const response = await axios.get(tenantUrl + '/v2/exports/product-link/' + id + '/files/' + fileName + signature(), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
        });
        return response;
    }
    // end product link

    // stock movements
    async getStockMovement(queryString = '') {
      const response = await axios.get(tenantUrl + '/v2/exports/stock-movement' + signature(queryString), config);
      return response;
    }
    async getStockMovementCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-movement/create' + signature(), config);
        return response;
    }
    async postStockMovement(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/stock-movement' + signature(), data, config);
        return response;
    }
    async getStockMovementInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-movement/' + id + signature(), config);
        return response;
    }
    async getStockMovementLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/stock-movement/' + id + '/logs' + signature(), config);
        return response;
    }
    async getStockMovementFile(id, fileName) {
      const response = await axios.get(tenantUrl + '/v2/exports/stock-movement/' + id + '/files/' + fileName + signature(), {
          headers: {
              Authorization: 'Bearer ' + ACCESS_TOKEN.token,
              TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
      });
      return response;
    }
    // end stock movements

    //marketplace stock movement
    async getMarketplaceStockMovement(queryString = '') {
        const response = await axios.get(tenantUrl + '/v2/exports/marketplace-stock-movement' + signature(queryString), config);
        return response;
    }

    async getMarketplaceStockMovementCreate() {
        const response = await axios.get(tenantUrl + '/v2/exports/marketplace-stock-movement/create' + signature(), config);
        return response;
    }
    
    async postMarketplaceStockMovement(data) {
        const response = await axios.post(tenantUrl + '/v2/exports/marketplace-stock-movement' + signature(), data, config);
        return response;
    }

    async getMarketplaceStockMovementInfo(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/marketplace-stock-movement/' + id + signature(), config);
        return response;
    }

    async getMarketplaceStockMovementLog(id) {
        const response = await axios.get(tenantUrl + '/v2/exports/marketplace-stock-movement/' + id + '/logs' + signature(), config);
        return response;
    }

    async getMarketplaceStockMovementFile(id, fileName) {
        const response = await axios.get(tenantUrl + '/v2/exports/marketplace-stock-movement/' + id + '/files/' + fileName + signature(), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            responseType: "arraybuffer" // need response type 'arraybuffer' (default response type is set to 'json')
        });
        return response;
    }
    //end marketplace stock movement
}

class Document {
    async getDocument() {
        return await axios.get(tenantUrl + '/v1/service/document', config);
    }
    async getDocumentLogs(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/document/logs' + queryString, config);
    }
    async postDocument(data) {
        return await axios.post(tenantUrl + '/v1/service/document', data, config);
    }
}

class DocumentType {
    async getDocumentType(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/document-type' + queryString, config);
    }
}

class Print {
    async postPrint(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postMergePDF(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/merge-pdf', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postTimeOut(data) {
        try {
            const response = await axios.post(tenantUrl + '/v1/service/print/time-out', data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class Salepage {
    async getSalepage(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/salepage' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getSalePageById(id) {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/salepage/' + id, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async updateSalepage(data) {
        return await axios.put(tenantUrl + '/v1/service/salepage/updateSalepage', data, config);
    }

    async getSalepageIds(){
        return await axios.get(tenantUrl + '/v1/service/salepage/getSalepageIds', config);
    }

    async postSalePage(data) {
        return await axios.post(tenantUrl + '/v1/service/salepage', data, config);
    }

    async putSelePage(id, data, options = {}) {
        const response = await axios.put(tenantUrl + '/v1/service/salepage/' + id, data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async deleteSalePage(id) {
        return await axios.delete(tenantUrl + '/v1/service/salepage/' + id, config);
    }

    async postDuplicateSalePage(id, data = {}) {
        return await axios.post(tenantUrl + '/v1/service/salepage/' + id + '/duplicate', data, config);
    }

    async findProductSalePage(id) {
        return await axios.get(tenantUrl + '/v1/service/salepage/product/' + id, config);
    }

    async postProductSalePage(data) {
        return await axios.post(tenantUrl + '/v1/service/salepage/product/update-price', data, config);
    }

    async getProductById(id) {
        return await axios.get(tenantUrl + '/v1/service/salepage/productshow/' + id, config);
    }

    async getShortenUrl(id, data) {
        const response = await axios.post(tenantUrl + '/v1/service/salepage/' + id + '/getshortenurl', data, config);
        return response.data;
    }

    async checkDelete(id) {
        const response = await axios.get(tenantUrl + '/v1/service/salepage/' + id + '/checkDelete', config);
        return response.data;    }

    async enableSalePage(data) {
        return await axios.post(tenantUrl + '/v1/service/salepage/enable', data, config);
    }

    async getIntegration(queryString = '', options = {}) {
        try {
            const response = await axios.get(tenantUrl + '/v1/service/salepage/integration' + queryString, config);
            if (options.dataReady) {
                return response.data;
            }
            return response;
        } catch (err) {
            let data = {
                'status': err.response.status,
                'statusText': err.response.data.message ? err.response.data.message : err.response.statusText,
            }
            console.error(err);
            return data;
        }
    }

    async getIntegrationById(integrationId) {
        const response = await axios.get(tenantUrl + '/v1/service/salepage/integration/' + integrationId, config);
        return response;
    }
}

class Domain {
    async getDomain(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/domain' + queryString, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getDomainById(id) {
        return await axios.get(tenantUrl + '/v1/service/domain/' + id, config);
    }

    async getDomainLogs(id) {
        return await axios.get(tenantUrl + '/v1/service/domain/' + id + '/logs', config);
    }

    async postDomainVerifyDnsTxt(id, data) {
        return await axios.post(tenantUrl + '/v1/service/domain/' + id + '/verify-dns-txt', data, config);
    }

    async postDomainDefaultSalepage(id, data) {
        return await axios.post(tenantUrl + '/v1/service/domain/' + id + '/default-salepage', data, config);
    }

    async reconnectDomain(id, data) {
        return await axios.put(tenantUrl + '/v1/service/domain/' + id + '/reconnect', data, config);
    }

    async postAddDomain(data) {
        return await axios.post(tenantUrl + '/v1/service/domain', data, config);
    }

    async deleteDomain(id) {
        return await axios.delete(tenantUrl + '/v1/service/domain/' + id, config);
    }

    async putDisableDomain(id, data) {
        return await axios.put(tenantUrl + '/v1/service/domain/' + id + '/disable', data, config);
    }

    async putEnableDomain(id, data) {
        return await axios.put(tenantUrl + '/v1/service/domain/' + id + '/enable', data, config);
    }

}
class SocialCodeType {
    async getSocialCodeType(queryString = '') {
        return await axios.get(tenantUrl + '/v1/service/socialcode-type' + queryString, config);
    }
}

class Announcement {

    async getAnnouncement() {
        return await axios.get(tenantUrl + '/v1/service/announcement', config);
    }

    async acceptAnnouncement(announcementId) {
        const response = await axios.post(tenantUrl + '/v1/service/announcement/' + announcementId, null, config);
        return response;
    }
}
class Notification {
    async getNotification(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/notification' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getNotificationHistory() {
        return await axios.get(tenantUrl + '/v1/service/notification/history', config);
    }
    async getNotificationUnread() {
        return await axios.get(tenantUrl + '/v1/service/notification/unread', config);
    }
    async addNotificationRead() {
        const response = await axios.post(tenantUrl + '/v1/service/notification/read', '', config);
        return response;
    }

}
class NotificationType {
    async getNotificationType(queryString = '', options = {}) {
        const response = await axios.get(tenantUrl + '/v1/service/notification-type' + queryString, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

}

class Feature {
    async postHasFeature(featureSlug) {
        var data = { featureSlug: featureSlug };
        return await axios.post(tenantUrl + '/v1/service/has/feature', data, config);
    }
    async postHasUsage(usageSlug) {
        var data = { usageSlug: usageSlug };
        return await axios.post(tenantUrl + '/v1/service/has/usage', data, config);
    }
}

class PlanSubscription {
    async getPlanSubscription() {
        try{
            const response = await axios.get(tenantUrl + '/v1/service/plan-subscription', config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

    async getExceedLimit(){
        const response = await axios.get(tenantUrl + '/v1/service/plan-subscription/exceed-limit', config);
        return response;
    }
}
class Inventory {
  async getCreateInventory() {
    const response = await axios.get(tenantUrl + '/v2/inventories/activate-data'+signature(),config);
    return response;

  }
  async getInventoryList(queryString = "") {
    try {
        return  await axios.get(tenantUrl + '/v2/inventories'+signature(queryString), {
            headers: {
                Authorization: 'Bearer ' + ACCESS_TOKEN.token,
                TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
        });
    } catch (error) {
        return error.response
    }


  }
  async getInventoryById(inventoryId) {
    // let config = {
    //     headers: {
    //       // "Access-Control-Allow-Origin": "*",
    //       // 'Access-Control-Allow-Credentials':true
    //     }
    // };
    // const response =  axios.get('http://localhost:3002/api/v2/stores/1', config);
    // return response;
    try {
        return  await axios.get(tenantUrl + '/v2/inventories/product/' + productId + signature(), config);
    } catch (error) {
        return error.response
    }
  }
  async getProductInfoById(productId) {
    try {
        return  await axios.get(tenantUrl + '/v2/inventories/product/' + productId + signature(), config);
    } catch (error) {
        return error.response
    }
  }
  async getInventoryInfoById(productId, queryString) {
    try {
        return  await axios.get(tenantUrl + '/v2/inventories/product/' + productId + '/warehouses' + signature(queryString), config);
    } catch (error) {
        return error.response
    }
  }
  async updateStockAlert(stockId, data) {
    try {
        const response = await axios.put(tenantUrl + '/v2/inventories/stock/'+ stockId + signature(), data, config);
        return response;
    } catch (error) {
        return error.response
    }
  }

  async getInventoryLogs(stockId) {
    try {
        return  await axios.get(tenantUrl + `/v2/inventories/stock/${stockId}/logs` + signature(), config);
    } catch (error) {
        return error.response
    }
  }

  async getProductInventory(queryString) {
    const response =  axios.get(tenantUrl + '/v2/inventories/products' + signature(queryString), config);
    return response;

  }
  async getProducLinkInventory(queryString) {
    const response =  axios.get(tenantUrl + '/v2/inventories/products/links' + signature(queryString), config);
    return response;

  }
  async postInventory(data='') {
    const response = await axios.post(tenantUrl + '/v2/inventories/activate' + signature(), data, config);
    return response;
}
  async getWarehouselist(queryString) {

    const response = await axios.get(tenantUrl + '/v2/inventories/warehouses'+ signature(queryString),config);
    return response;
  }
  async getWarehousesPurchase(queryString) {

    const response = await axios.get(tenantUrl + '/v2/inventories/purchases/warehouses'+ signature(queryString),config);
    return response;
  }

  async getWarehouses(warehouseId = null) {
    const response = await axios.get(tenantUrl + '/v2/inventories/warehouses/' + warehouseId + signature(),config);
    return response;
  }
  async getProductWarehouses(warehouseId,queryString) {
    const response =  axios.get(tenantUrl + '/v2/inventories/warehouses/'+warehouseId+'/products' + signature(queryString), config);
    return response;
  }
  async deleteWarehouses(warehouseId) {
    const response = await axios.delete(tenantUrl + '/v2/inventories/warehouses/' + warehouseId + signature(), config);
    return response;
  }
  async getLocationWarehousesUpdate(warehouseId = null) {
    const response = await axios.get(tenantUrl + '/v2/inventories/warehouses/'+ warehouseId + '/update' + signature(), config);
    return response;
  }
  async getLocationWarehousesCreate() {
    const response = await axios.get(tenantUrl + '/v2/inventories/warehouses/create' + signature(), config);
    return response;
  }
  async createWarehouses(data='') {
    const response = await axios.post(tenantUrl + '/v2/inventories/warehouses' + signature(), data, config);
    return response;
  }
  async updateWarehouses(warehouseId = null,data='') {
    const response = await axios.put(tenantUrl + '/v2/inventories/warehouses/'+ warehouseId+ signature(), data, config);
    return response;
  }

  async setDefaultWarehouse(warehouseId = null,data='') {
    const response = await axios.post(tenantUrl + '/v2/inventories/warehouses/'+ warehouseId + signature(), data, config);
    return response;
  }
    async getLogsWarehouse(warehouseId) {
        return await axios.get(tenantUrl + '/v2/inventories/warehouses/' + warehouseId + '/logs' + signature(), config)
    }

    async getShipment(warehouseId,queryString) {
        return await axios.get(tenantUrl + '/v2/inventories/warehouses/' + warehouseId + '/shipments' + signature(queryString), config)
    }

  async getStockMovementOrderList(queryString) {
    const response = await axios.get(tenantUrl + `/v2/products/order-movement` + signature(queryString), config);
    return response;
  }
  async getStockMovementList(productId, queryString) {
    const response = await axios.get(tenantUrl + `/v2/inventories/product/${productId}/stock-movements` + signature(queryString), config);
    return response;
  }
  async getStockMovementListLink(productId, linkId, queryString) {
    const response = await axios.get(tenantUrl + `/v2/products/links/${linkId}/inventories/${productId}/stock-movements` + signature(queryString), config);
    return response;
  }
  async getStockMovementOrderListLink(queryString) {
    const response = await axios.get(tenantUrl + `/v2/products/links/order-movement` + signature(queryString), config);
    return response;
  }
  async getWarehousePlanLimit(queryString) {
    return await axios.get(tenantUrl + '/v2/inventories/warehouses/plan-limit' + signature(queryString), config)
  }
  async manageWarehouse(data) {
    return await axios.post(tenantUrl + '/v2/inventories/warehouses/plan-limit' + signature(), data, config)
  }

  async deactivate(data='') {
    const response = await axios.post(tenantUrl + '/v2/inventories/deactivate' + signature(), data, config);
    return response;
  }

  async checkWarehouse(data = '') {
    const response = await axios.post(tenantUrl + '/v2/inventories/skip-rts/batch/check-warehouses' + signature(), data, config);
    return response;
  }
  async ignoreProducts(data = '') {
    const response = await axios.post(tenantUrl + '/v2/inventories/skip-rts/batch/ignore' + signature(), data, config);
    return response;
  }
  async getProductLists(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/skip-rts/products'+ signature(queryString),config);
    return response;
  }
  async getProductPromotion(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/create' + signature(queryString), config);
    return response
  }
  async createInventory(data) {
    const response = await axios.post(tenantUrl + '/v2/inventories/create' + signature(), data, config);
    return response
  }

}
class ActivitiesV2 {
    async getActivities(queryString = null) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities' + signature(queryString), config);
            // console.log('response = ',response);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err.response;
        }
    }

    async getActivitiesCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/create' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getActivitiesCreateBatch(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/create' + signature(queryString), config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err.response;
        }
    }
    async postActivitiesCreateBatch(data) {
        const response = await axios.post(tenantUrl + '/v2/crm/activities/batch'+ signature(), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async getActivitiesDetail(id, queryString='') {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/'+id+'/edit' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async deleteActivitiesById(activitieId = null) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/crm/activities/' + activitieId + signature(), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getActivitiesInfo(activitieId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + signature(), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getActivitiesInfoData(activitieId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/info-data' + signature(), config);
            if (options.dataReady) {
                return response.data.data;
            }
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getStaff(queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/staffs' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async postActivities(data,queryString='') {
        const response = await axios.post(tenantUrl + '/v2/crm/activities'+ signature(queryString), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async putActivities(id, data,queryString='') {
        const response = await axios.put(tenantUrl + '/v2/crm/activities/'+ id + signature(queryString), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async deleteActivities(activitieId = [], options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/batch/update/delete' + signature(),activitieId, config);
            if (options.dataReady) {
                return response;
            }
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async updateStaffBatch(data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/batch/update/staff' + signature(),data, config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getActivitiesOrderHistory(activitieId,data) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/orders' + signature(data), config);
            return response;

        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async updateCompleteBatch(activitieId = []) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/batch/update/complete' + signature(),activitieId, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async updateIncompleteBatch(activitieId = []) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/batch/update/incomplete' + signature(),activitieId, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getActivitiesLog(activitieId, options = {}) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/logs' + signature(), config);
            return response;

        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async postAddTag(activitieId, data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/crm/activities/' + activitieId + '/tags' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async deleteActivitiesTag(activitieId, tagId) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/crm/activities/' + activitieId + '/tags/'+ tagId + signature(), config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async incompleteActivitiesById(activitieId, data = null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/' + activitieId + '/incomplete' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async completeActivitiesById(activitieId, data = null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/crm/activities/' + activitieId + '/complete' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getActivitiesFollowById(activitieId, data = null) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/follow' + signature(), config);
            return response;

        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getActivitiesFollowReasonById(activitieId, data = null) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/follow-reason' + signature(), config);
            return response;

        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async postActivitiesFollowById(activitieId, data = null) {
        try{
            const response = await axios.post(tenantUrl + '/v2/crm/activities/' + activitieId + '/follow' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async postActivitiesFollowReasonById(activitieId, data = null) {
        try{
            const response = await axios.post(tenantUrl + '/v2/crm/activities/' + activitieId + '/follow-reason' + signature(), data, config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async deleteActivitiesFollowReasonById(activitieId, followReasonId) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/crm/activities/' + activitieId + '/follow-reason/'+ followReasonId + signature(), config);
            return response;
        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getTagById(activitieId,queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/crm/activities/' + activitieId + '/tags' + signature(queryString), config);
            return response;
        } catch (err) {
            // console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }

}
class Adjustments {
    async getAdjustmentsList(queryString) {
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments' + signature(queryString), config)
        return response;
    }
    async getAdjustmentsById(adjustmentsId) {
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/' + adjustmentsId + signature(), config);
        return response;
    }
    async getProduct() {
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/products' + signature(queryString), config)
        return response;
    }

    async createAdjustments(data,queryString='') {
        const response = await axios.post(tenantUrl + '/v2/inventories/adjustments'+ signature(queryString), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async getAdjustmentsActivityLog(adjustmentsId, data, options = {}){
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/' + adjustmentsId + '/logs' + signature(data), config);
        return response
    }
    async getProductAdjustment(warehouseId, wmsId, queryString) {
      const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/warehouses/' + warehouseId + '/products/' + wmsId + signature(queryString), config);
      return response
  }
    async getProductPromotion(warehouseId, queryString) {
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/warehouses/' + warehouseId + '/products' + signature(queryString), config);
        return response
    }
    async getAdjustmentsCreate(queryString='') {
        try{
        const response = await axios.get(tenantUrl + '/v2/inventories/adjustments/create' + signature(queryString), config);
        return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }
    async getProductItem(data = '') {
      const response = await axios.post(tenantUrl + '/v2/inventories/adjustments/products' + signature(), data, config);
      return response;
    }
    async updateRemarkAdjusments(adjusmentId = null,data='') {
      const response = await axios.put(tenantUrl + '/v2/inventories/adjustments/'+ adjusmentId + '/update-remark' + signature(), data, config);
      return response;
    }
}

class SubscriptionV2 {
    async postCreate(data = null) {
      return await axios.post(tenantUrl + '/v2/subscriptions' + signature(), data, config);
    }
    async getPlansInfo(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/subscriptions' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getPlansSelect(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/subscriptions/plans' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPlansCreate(queryString = null) {
        try{
            const response = await axios.get(tenantUrl + '/v2/subscriptions/create' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postPlansCreate(data = null) {
        try{
            const response = await axios.post(tenantUrl + '/v2/subscriptions' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async postPayment(id,data = null) {
        try{
            const response = await axios.post(tenantUrl + '/v2/subscriptions/'+ id +'/payment' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPayment(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/subscriptions/'+ id +'/payment/re-new' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class StoresV2 {
  async getStores(queryString = null) {
    try{
      const response = await axios.get(tenantUrl + '/v2/stores' + signature(queryString), config);
      return response;
    } catch (err) {
      if (err.response.status !== 403) {
        handleApi(err);
      }
      return err.response;
    }
  }
}

class WalletV2 {
  async getTransactions(queryString = null) {
    try{
      const response = await axios.get(tenantUrl + '/v2/wallets/transactions' + signature(queryString), config);
      return response;
    } catch (err) {
      if (err.response.status !== 403) {
        handleApi(err);
      }
      return err.response;
    }
  }
}

class NotificationRead {

}
class Suppliers {
  async getSuppliersList(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/suppliers'+signature(queryString),config);
    return response;
  }
  async getSuppliers(suppliersId) {
    const response = await axios.get(tenantUrl + '/v2/inventories/suppliers/'+suppliersId+signature(),config);
    return response;
  }
  async getSuppliersLog(suppliersId) {
    const response = await axios.get(tenantUrl + '/v2/inventories/suppliers/'+suppliersId+'/logs'+signature(),config);
    return response;
  }
  async getSuppliersCreate() {
    const response = await axios.get(tenantUrl + '/v2/inventories/suppliers/create'+signature(),config);
    return response;
  }
  async createSuppliers(data='') {
    const response = await axios.post(tenantUrl + '/v2/inventories/suppliers' + signature(), data, config);
    return response;
  }
  async getUpdateSuppliers(suppliersId) {
    const response = await axios.get(tenantUrl + '/v2/inventories/suppliers/'+suppliersId+'/update'+signature(),config);
    return response;
  }
  async updateSuppliers(suppliersId = null,data='') {
    const response = await axios.put(tenantUrl + '/v2/inventories/suppliers/'+ suppliersId+ signature(), data, config);
    return response;
  }


}
class Purchases {
    async getPurchasesList(queryString) {
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases'+signature(queryString),config);
        // let config = {
        //   headers: {
        //     // "Access-Control-Allow-Origin": "*",
        //     // 'Access-Control-Allow-Credentials':true
        //   }
        // };
        // const response = await axios.get('http://localhost:3002/api/v2/purchases',config);
        return response;
    }

    async getPurchases(purchasesId) {
        // const response = await axios.get(tenantUrl + '/v2/suppliers'+signature(),config);
        let config = {
        headers: {
            // "Access-Control-Allow-Origin": "*",
            // 'Access-Control-Allow-Credentials':true
        }
        };
        const response = await axios.get('http://localhost:3002/api/v2/purchases/'+purchasesId,config);
        return response;
    }

    async getPurchasesById(purchaseId) {
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases/' + purchaseId + signature(), config);
        return response;
    }

    async createPurchasess(data,queryString='') {
        const response = await axios.post(tenantUrl + '/v2/inventories/purchases'+ signature(queryString), data, config)
        .then(response => {
            return response;
        }).catch(function (error) {
            if (error.response) {
            return error.response;
            }
        });
        return response;
    }

    async getActivitiesLog(activitieId, options = {}) {
        try{
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases/' + activitieId + '/logs' + signature(), config);
        return response;

        } catch (err) {
        if (err.response.status !== 403) {
            handleApi(err);
        }
        return err.response;
        }
    }

    async confirmPurchase(purchaseId, data) {
        const response = await axios.post(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/confirm' + signature(), data, config);
        return response
    }
    async confirmTransfer(transferId, data) {
      const response = await axios.post(tenantUrl + '/v2/inventories/transfers/' + transferId + '/confirm' + signature(), data, config);
      return response
    }

    async cancelPurchase(purchaseId, data) {
        const response = await axios.post(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/cancel' + signature(), data, config);
        return response
    }

    async getPurchaseCreate(queryString='') {
        try{
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases/create' + signature(queryString), config);
        return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getWarehouseDetail(warehouse_id) {
        try{
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases/warehouses/'+ warehouse_id + signature(), config);
        return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async getProduct(queryString) {
      const response =  axios.get(tenantUrl + '/v2/inventories/purchases/products' + signature(queryString), config);
      return response;

    }
    async getProductPurchase(wmsId, queryString) {
      const response =  axios.get(tenantUrl + '/v2/inventories/purchases/products/' + wmsId + signature(queryString), config);
      return response;

  }

    async getConfirmPartial(purchaseId) {
        const response =  axios.get(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/confirm-partial' + signature(), config);
        return response;
    }

    async confirmPartial(purchaseId, data) {
        const response = await axios.post(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/confirm-partial' + signature(), data, config);
        return response
    }
    async getPurchasesDetail(purchaseId) {
      try{
        const response = await axios.get(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/update' + signature(), config);
        return response;
      } catch (err) {
        if (err.response.status !== 403) {
          handleApi(err);
        }
        return err.response;
      }
    }

    async updatePurchases(data, purchaseId) {
      const response = await axios.put(tenantUrl + '/v2/inventories/purchases/' + purchaseId + signature(), data, config);
      return response;
    }
    async createPayments(purchaseId, data) {
      try{
        const response = await axios.post(tenantUrl + '/v2/inventories/purchases/' + purchaseId + '/payments' + signature(), data, config);
        return response
      }catch (err) {
          return err.response;
      }
    }

}
class StockMovements {
  async getStockMovementsList(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/stock-movements'+signature(queryString),config);
    return response;
  }
  async getStockMovementsOrderList(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/order-movement'+signature(queryString),config);
    return response;
  }
  async getSalesChannel(queryString) {
    const response = await axios.get(tenantUrl + '/v2/inventories/sales-channel'+signature(queryString), config);
    return response;
  }

}

class PickUp {
    async getPickUpLogs(queryString) {
        const response = await axios.get(tenantUrl + '/v1/service/shipment/pickup/logs'+signature(queryString),config);
        return response.data;
    }

    async getPickUpList(queryString){
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/pickup/list'+signature(queryString),config);
            return response;
        } catch (err) {
            console.error(err);
            let data = {
                'status': false,
                'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
            }
            return data;
        }
    }

    async getPickUpDocument(data) {
        const response = await axios.post(tenantUrl + '/v1/service/print/pickup' + signature(), data, config);
        return response.data;
    }

    async getDetailPickUp(id){
        try {
            const response = await axios.get(tenantUrl + '/v1/service/shipment/pickup/'+id,config);
            return response;
        } catch (err) {
            console.error(err);
            let data = {
                'status': false,
                'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
            }
            return data;
        }
    }

    async postDeletePickup(id, data) {
        const response = await axios.put(tenantUrl + '/v1/service/shipment/pickup/'+id, data, config);
        return response;
    }
}
class PlanSubscriptionV2 {
    async getPlanSubscriptionV2(queryString = null) {
        try{
            const response = await axios.get(tenantUrl + '/v2/coupons/list' + signature(queryString), config);
            return response;

        } catch (err) {
            console.log('err',err);
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err.response;
        }
    }

    async postCouponV2(data) {
        const response = await axios.post(tenantUrl + '/v2/coupons'+ signature(), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }
}


class ShipmentV3 {
    async getShipment(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v3/shipments' + signature(queryString), config);
            return response;
        } catch (err) {
            if (err.response.status !== 403) {
                handleApi(err);
            }
            return err;
        }
    }
}

class FulfillmentV2 {
    async getFulfillmentOrder(queryString = '') {
        return await axios.get(tenantUrl + '/v2/fulfillment/orders' + signature(queryString), config);
    }

    async getFulfillmentOrderDetail(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/orders/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentOrderDetailActivityLogs(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/orders/' + id + '/activity-logs' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putFulfillmentOrderCancel(data) {
        return await axios.put(tenantUrl + '/v2/fulfillment/orders/bulk-cancel' + signature(), data, config);
    }

    async getFulfillmentProduct(queryString = '') {
        return await axios.get(tenantUrl + '/v2/fulfillment/products' + signature(queryString), config);
    }

    async getProductFulfillmentTab(id, queryString = '') {
        return await axios.get(tenantUrl + '/v2/products/' + id + '/fulfillment' + signature(queryString), config);
    }

    async getFulfillmentProductDetail(id, queryString) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/products/' + id + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentProductActivityLog(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/products/' + id + '/activity-logs'+ signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentConnections(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentProductInternal(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/search/product/list/simple' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentProductExternal(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/search/product/list/external' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentProductListLink(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/search/product/list/link' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postFulfillmentConnections(data) {
        const response = await axios.post(tenantUrl + '/v2/fulfillment/connections'+ signature(), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }

    async getFulfillmentConnectionsDetailInternal(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections/'+id+'/internal' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentConnectionsDetailExternal(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections/' + id + '/external' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentConnectionsActivityLogs(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections/' + id + '/activity-logs' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentConnectionsInfo(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections/' + id + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getFulfillmentConnectionsCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/fulfillment/connections/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putFulfillmentConnectionsUpdate(id, data, options = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/fulfillment/connections/' + id + '/update' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postFulfillmentDisconnect(data) {
        const response = await axios.post(tenantUrl + '/v2/fulfillment/connections/disconnect'+ signature(), data, config)
            .then(response => {
                return response;
            }).catch(function (error) {
                if (error.response) {
                    return error.response;
                }
            });
        return response;
    }
}


class ToolV2 {
    async getLabelProductCreate(queryString = '') {
        try{
        const response = await axios.get(tenantUrl + '/v2/products/labels/create' + signature(queryString), config);
        return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductCreate(queryString = '') {
        try{
        const response = await axios.get(tenantUrl + '/v2/label/product/create' + signature(queryString), config);
        return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductItem(queryString = '') {
        try{
        const response = await axios.get(tenantUrl + '/v2/products/labels/products' + signature(queryString), config);
        return response;
        } catch (err) {
            return err.response;
        }
    }
    async postProductItem(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/products/labels'+ signature(), data, config)
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getProductLabel(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/products/labels' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postPrintProductLabel(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/products/labels/print' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async createForm(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/forms' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getFormList(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getFormDetail(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getFormLogs(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/' + id + '/logs' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getFormDataEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putFormEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getFormDataDuplicate(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/' + id + '/duplicate' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async postFormDataDuplicate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/forms/duplicate' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async deleteFormById(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/forms/' + id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getEntriesListByFormId(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/' + id + '/submit' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getEntriesDetail(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/submit/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getEntryDataEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/submit/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putEntryEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/submit/' + id + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getEntriesLogs(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/forms/submit/' + id + '/logs' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putResendEmailConfirm(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + '/submit/batch/send-email' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putConfirmEntries(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + '/submit/batch/confirm' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putRejectEntries(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + '/submit/batch/reject' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async putDeleteEntries(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + '/submit/batch/delete' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
    async getEntriesDownload(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/forms/' + id + '/submit/batch/export' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPackaging(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/packages' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postEntryScan(data = {}) {
        try{
            const response = await axios.post(tenantUrl + '/v2/forms/submit/scan' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPackagingCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/packages/create' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async postPackagingCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/packages' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPackagingDetail(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/packages/' + id + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async getPackagingEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/packages/' + id + '/edit' + signature(), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putPackagingEdit(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/packages/' + id + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async putPackagingDefault(id, data = {}) {
        try{
            const response = await axios.put(tenantUrl + '/v2/packages/' + id + '/default' + signature(), data, config);
            return response;
        }catch (err) {
            return err.response;
        }
    }

    async deletePackaging(id) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/packages/' + id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPackagingLogs(queryString = '', id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/packages/' + id + '/logs' + signature(queryString), config);
            return response;
        }catch (err) {
            return err.response;
        }
    }
}

class ReturnOrder {

    async getReturnOrderCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/shipments-data' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getSearchReturnOrderCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/shipments' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getManageReturnOrderCreate(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/create' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getManageReturnOrderEdit(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/edit' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postReturnOrderCreate(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/returns' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderEdit(id, data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderList(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderInfo(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderItem(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/items' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderNotes(id,queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/notes' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderLogs(id,queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/logs' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postReturnOrderNoteCreate(id,data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/returns/' + id + '/notes' + signature(),data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderNoteUpdate(id, noteId, data) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/notes/' + noteId + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getReturnOrderNotesUpdate(id, noteId) {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/notes/' + noteId + '/edit' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderApprove(id,data=null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/approve' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderReject(id,data=null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/reject' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderCancel(id,data=null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/cancel' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderNotesPin(id,noteId,data=null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/notes/' + noteId + '/pin' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async putReturnOrderNotesUnPin(id,noteId,data=null) {
        try{
            const response = await axios.put(tenantUrl + '/v2/returns/' + id + '/notes/' + noteId + '/unpin' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async deleteReturnOrderNotes(id,noteId) {
        try{
            const response = await axios.delete(tenantUrl + '/v2/returns/' + id + '/notes/' + noteId + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getConfirmData(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/returns/'+ id +'/confirm' + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async postReturnOrderConfirm(id, data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/returns/' + id + '/confirm' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class ShippingCredit {
    async getCreate() {
        try{
            const response = await axios.get(tenantUrl + '/v2/shipping-credit/create'+ signature(), config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err;
        }
    }
    async createPayment(data) {
        try{
            const response = await axios.post(tenantUrl + '/v2/shipping-credit'+ signature(), data, config);
            return response;
        } catch (err) {
            // if (err.response.status !== 403) {
            //     handleApi(err);
            // }
            return err;
        }
    }
    async postPayment(id,data = null) {
        try{
            const response = await axios.post(tenantUrl + '/v2/shipping-credit/'+ id +'/payment' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }

    async getPayment(id) {
        try{
            const response = await axios.get(tenantUrl + '/v2/shipping-credit/'+ id +'/payment/re-new' + signature(), config);
            return response;
        } catch (err) {
            return err;
        }
    }
}
class PurchaseApps {
    async getApps(queryString = '') {
        try{
            const response = await axios.get(tenantUrl + '/v2/subscriptions/apps' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

export default {
    Setup: new Setup(),
    Authorization: new Authorization(),
    Signature: new Signature(),
    AUTH: {
        URL: tenantUrl,
        TOKEN: ACCESS_TOKEN.token
    },
    URL: {
        CUSTOMER: API_CUSTOMER,
        PRODUCT: API_PRODUCT,
        ROLE: API_ROLE,
        ORDER: API_ORDER,
        ORDER_GETPRODUCT: API_ORDER_GETPRODUCT,
        INVENTORY_GETPRODUCT: API_INVENTORY_GETPRODUCT,
        INTEGRATION: API_INTEGRATION,
        SETTING_GETPRODUCT: API_SETTING_GETPRODUCT,
        SHIPMENT_GETPRODUCT: API_SHIPMENT_GETPRODUCT,
        SETTING_GETUSER: API_SETTING_GETUSER,
        SETTING_GETUSERASSIGN: API_SETTING_GETUSERASSIGN,
        SALEPAGE_GETPRODUCT: API_SALEPAGE_GETPRODUCT,
        TAG: API_TAG,
        ORDER_NOTIFY: API_ORDER_NOTIFY,
        NOTIFY: API_NOTIFY,
        SETTING_GETLOCATION: API_SETTING_GETLOCATION,
        PRODUCTLINK_GETPRODUCT: API_PRODUCTLINK_GETPRODUCT,

        CUSTOMER_TAG: API_CUSTOMER_TAG,
        PAYMENTS_TAGS: API_PAYMENTS_TAGS,
        ACTIVITIES_GET: API_ACTIVITIES,
        ACTIVITIES_STAFF:API_ACTIVITIES_STAFF,
        CUSTOMER_ACTIVITY_STAFF: API_CUSTOMER_ACTIVITY_STAFF,
        ACTIVITIES_TAG: API_ACTIVITIES_TAG,
        PRODUCTLINK_ITEM_FILTER: API_PRODUCTLINK_ITEM_FILTER,
        PRODUCTLINK_GETPRODUCTLINK: API_PRODUCTLINK_GETPRODUCTLINK,
        INVENTORY_GETWAREHOUSE: API_INVENTORY_GETWAREHOUSE,
        INVENTORY_GETCHANNEL: API_INVENTORY_GETCHANNEL,
        INVENTORY_GETSUPPLIER: API_INVENTORY_GETSUPPLIER,
        ADJUSTMENTS_GETWAREHOUSE: API_ADJUSTMENTS_GETWAREHOUSE,
        SHIPMENTS_GETWAREHOUSE: API_SHIPMENTS_GETWAREHOUSE,
        IMPORTS_GETWAREHOUSE: API_IMPORTS_GETWAREHOUSE,
        TIMESLOT: API_TIMESLOT,
        PRODUCT_TAG: API_PRODUCT_TAG,
        PRODUCT_CATEGORIES: API_PRODUCT_CATEGORIES,
        PRODUCT_RETURNORDER: API_PRODUCT_RETURNORDER,

        FULFILLMENT_PRODUCT_EXTERNAL: API_FULFILLMENT_PRODUCT_EXTERNAL,
        FULFILLMENT_PRODUCT_INTERNAL: API_FULFILLMENT_PRODUCT_INTERNAL,
        ACTIVITIES_CUSTOMER_TAG: API_ACTIVITIES_CUSTOMER_TAG,
        SALEPAGE_NOTIFY_ORDER: API_SALEPAGE_NOTIFY_ORDER
    },
    Tag: new Tag(),
    Bank: new Bank(),
    BankAccount: new BankAccount(),
    User: new User(),
    UserV2: new UserV2(),
    Country: new Country(),
    Note: new Note(),
    ProductTag: new ProductTag(),
    ProductType: new ProductType(),
    ProductConfig: new ProductConfig(),
    ProductVariation: new ProductVariation(),
    Product: new Product(),
    ProductV2: new ProductV2(),
    ProductLink: new ProductLink(),
    Category: new Category(),
    Role: new Role(),
    Invitation: new Invitation(),
    Order: new Order(),
    OrderV2: new OrderV2(),
    OrderV3: new OrderV3(),
    OrderDraft: new OrderDraft(),
    UpsellV2: new UpsellV2(),
    Payment: new Payment(),
    Automation: new Automation(),
    AutomationV2: new AutomationV2(),
    PaymentV2: new PaymentV2(),
    Gender: new Gender(),
    Integration: new Integration(),
    IntegrationType: new IntegrationType(),
    IntegrationV2: new IntegrationV2(),
    PaymentMethod: new PaymentMethod(),
    Customer: new Customer(),
    CustomerGroup: new CustomerGroup(),
    BuildingType: new BuildingType(),
    Media: new Media(),
    Attribute: new Attribute(),
    AttributeOption: new AttributeOption(),
    Shipment: new Shipment(),
    ShipmentV2: new ShipmentV2(),
    Label: new Label(),
    Receipt: new Receipt(),
    DeliveryOrder: new DeliveryOrder(),
    TaxInvoice: new TaxInvoice(),
    Location: new Location(),
    LocationType: new LocationType(),
    LocationDefault: new LocationDefault(),
    PermissionGroup: new PermissionGroup(),
    AiSlip: new AiSlip(),
    Setting: new Setting(),
    SettingV2: new SettingV2(),
    FlatRate: new FlatRate(),
    Tenant: new Tenant(),
    ShippingLabel: new ShippingLabel(),
    Address: new Address(),
    Industry: new Industry(),
    Home: new Home(),
    Wallet: new Wallet(),
    Merchant: new Merchant(),
    Consignment: new Consignment(),
    Module: new Module(),
    Dashboard: new Dashboard(),
    Report: new Report(),
    ReportV2: new ReportV2(),
    Import: new Import(),
    ImportV2: new ImportV2(),
    Export: new Export(),
    ExportV2: new ExportV2(),
    Permission: new Permission(),
    Document: new Document(),
    DocumentType: new DocumentType(),
    Notification: new Notification(),
    NotificationType: new NotificationType(),
    Upsell: new Upsell(),
    Variation: new Variation(),
    Print: new Print(),
    Salepage: new Salepage(),
    Domain: new Domain(),
    SocialCodeType: new SocialCodeType(),
    PickingList: new PickingList(),
    ProductSet: new ProductSet(),
    Feature: new Feature(),
    Announcement: new Announcement(),
    PlanSubscription: new PlanSubscription(),
    ShippingRateItem: new ShippingRateItem(),
    ShippingRateItemRow: new ShippingRateItemRow(),
    ShippingRate: new ShippingRate(),
    PromotionBundleRule: new PromotionBundleRule(),
    Promotion: new Promotion(),
    PromotionV2: new PromotionV2(),
    DeliveryProof: new DeliveryProof(),
    PurchaseOrder: new PurchaseOrder(),
    Quotation: new Quotation(),
    Social: new Social(),
    Inventory: new Inventory(),
    ActivitiesV2:new ActivitiesV2(),
    Adjustments:new Adjustments(),
    Suppliers: new Suppliers(),
    Purchases: new Purchases(),
    StockMovements: new StockMovements(),
    SubscriptionV2:new SubscriptionV2(),
    VariationV2: new VariationV2(),
    StoresV2:new StoresV2(),
    WalletV2:new WalletV2(),
    PickUp: new PickUp(),
    PlanSubscriptionV2: new PlanSubscriptionV2(),
    ShipmentV3: new ShipmentV3(),
    FulfillmentV2: new FulfillmentV2(),
    ToolV2: new ToolV2(),
    ReturnOrder: new ReturnOrder(),
    ShippingCredit: new ShippingCredit(),
    PurchaseApps: new PurchaseApps(),
};



// WEBPACK FOOTER //
// ./src/services/endpoint/tenant.service.js